import React, { Component } from 'react';
import { Table, TableRow, TableCell, TableBody, TextField, TableFooter, Button, CircularProgress, FormControl, Card, } from '@material-ui/core';
import Box from '@mui/material/Box';
import {
    Avatar, IconButton,

} from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import AddIcon from '@material-ui/icons/Add';
// import AddIcon from '@mui/icons-material/Add';
import { Link } from 'react-router-dom';
import withUser from '../HOC/HOCwithUser.jsx';
import HOCLoader from '../HOC/HOCLoader.jsx';
import { getStatus, ROLE_PROVIDER, SERVER_URL, ROLE_CUSTOMER } from '../../utils/config/constants.js';
import moment from 'moment';
import { store } from '../../store';
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import Stack from '@mui/material/Stack';
// import AdapterDateFns from '@mui/lab/AdapterDateFns';
// import LocalizationProvider from '@mui/lab/LocalizationProvider';
// import MobileDatePicker from '@mui/lab/MobileDatePicker';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
// import { makeStyles, withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Image from 'react-bootstrap/Image';
import { NotificationManager } from 'react-notifications';
import Dropzone from 'react-dropzone';
import { getCookies } from '../../utils/getToken.js';
import Axios from 'axios';
import ReactCrop from 'react-image-crop';
import { connect } from 'react-redux';
import { compose } from 'redux';
import * as actions from '../../actions';
import { HighlightOff } from '@material-ui/icons';
// import DateTimePanel from '../Booking/DateTimePanel.jsx';
import { validateSignUpData } from '../../utils/validators/validateForm';

import { FormattedMessage, injectIntl } from 'react-intl';
import Datetime from 'react-datetime';
import ProviderTrainingCenter from '../Providers/ProviderTrainingCenter.jsx';
import ProviderBusinessHours from '../Providers/ProviderBusinessHours.jsx';
import AddressCreate from '../../views/Address/Create.jsx';
import Address from '../../views/User/Address.jsx';
import uploadIcon from '../../assets/img/profile-upload-icon.png'
import TermsConditions from '../Modals/Terms&Conditions.js';
// import DatePicker from '@mui/lab/DatePicker';


const AddImagesBox = ({ title, handleDropRejected, handleDrop, userData, imageUploaded, imageId, noOfUpload = 1, onlyAdd = false, imgUrl, base64 }) => {
    return (
        <React.Fragment>
            <Card sx={{ width: '100%', p: 3, flex: 1, alignItems: 'center' }}>
                {/* <Grid className="m-2">
                                                    <Grid container spacing={2}  
                                                    alignItems="center"
  justifyContent="center" >
                                                        <Grid key={0} item > */}
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', }}>
                        <Typography>{title}</Typography>
                        <Typography style={{ color: '#a432a8' }}>{`(*Allowed file size is 10MB and supports only JPEG/PNG)`}</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', columnGap: 2, jutifyContent: 'center', pt: 2 }}>
                        {(() => {
                            const arr = [];
                            for (let i = 0; i < noOfUpload; i++) {
                                // const imgData = 
                                {
                                    imgUrl[i].split("/")[3] === 'images' ?
                                        <React.Fragment>
                                            {
                                                base64 ?
                                                    arr.push(
                                                        <div style={{ width: 150, height: 100, background: '#b2b2b3', pt: '20px', mx: 3 }}>
                                                            {/* <p>Identity Front</p> */}
                                                            <Dropzone
                                                                onDrop={handleDrop}
                                                                accept="image/jpeg,image/jpg,image/png"
                                                                multiple={true}
                                                                maxSize={10485760}
                                                                onDropRejected={handleDropRejected}
                                                            >
                                                                {({ getRootProps, getInputProps }) => (
                                                                    <div {...getRootProps()}>
                                                                        <input {...getInputProps()} />
                                                                        {/* <p>
                                             <FormattedMessage
                                                 id="customer.dropfiles"
                                                 defaultMessage="Drop files here, or click to select files"
                                             />
                                         </p> */}
                                                                        {console.warn(imgUrl[i])}
                                                                        {/* <div><Image src={imageId.url} style={{ width: 200, height: 120 }} /></div> */}
                                                                        {
                                                                            base64 ?
                                                                                <Paper elevation={2}>
                                                                                    <Image src={`data:image;base64,${base64}`} thumbnail style={{ width: 200, height: 120 }} />
                                                                                </Paper> :
                                                                                <Paper elevation={2}>
                                                                                    <Image src={imgUrl[i]} thumbnail style={{ width: 200, height: 120 }} />
                                                                                </Paper>
                                                                        }

                                                                    </div>
                                                                )}
                                                            </Dropzone>
                                                        </div>
                                                    )

                                                    :

                                                    arr.push(
                                                        <div style={{ width: 150, height: 100, background: '#b2b2b3', pt: '20px', mx: 3 }}>
                                                            {/* <p>Identity Front</p> */}
                                                            <Dropzone
                                                                onDrop={handleDrop}
                                                                accept="image/jpeg,image/jpg,image/png"
                                                                multiple={true}
                                                                maxSize={10485760}
                                                                onDropRejected={handleDropRejected}
                                                            >
                                                                {({ getRootProps, getInputProps }) => (
                                                                    <div {...getRootProps()}>
                                                                        <input {...getInputProps()} />
                                                                        {/* <p>
                                        <FormattedMessage
                                            id="customer.dropfiles"
                                            defaultMessage="Drop files here, or click to select files"
                                        />
                                    </p> */}
                                                                        {console.warn(imgUrl[i])}
                                                                        {/* <div><Image src={imageId.url} style={{ width: 200, height: 120 }} /></div> */}
                                                                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', pt: 3, color: '#717175' }}>
                                                                            <Box > <AddIcon fontSize='large' /></Box>
                                                                            <Typography style={{ color: '#717175' }}>
                                                                                Add Photo
                                                                            </Typography>
                                                                        </Box>
                                                                    </div>
                                                                )}
                                                            </Dropzone>
                                                        </div>
                                                    )
                                            }
                                        </React.Fragment>



                                        :
                                        arr.push(
                                            <div style={{ width: 150, height: 100, background: '#b2b2b3', pt: '20px', mx: 3 }}>
                                                {/* <p>Identity Front</p> */}
                                                <Dropzone
                                                    onDrop={handleDrop}
                                                    accept="image/jpeg,image/jpg,image/png"
                                                    multiple={true}
                                                    maxSize={10485760}
                                                    onDropRejected={handleDropRejected}
                                                >
                                                    {({ getRootProps, getInputProps }) => (
                                                        <div {...getRootProps()}>
                                                            <input {...getInputProps()} />
                                                            {/* <p>
                                         <FormattedMessage
                                             id="customer.dropfiles"
                                             defaultMessage="Drop files here, or click to select files"
                                         />
                                     </p> */}
                                                            {console.warn(imgUrl[i])}
                                                            {/* <div><Image src={imageId.url} style={{ width: 200, height: 120 }} /></div> */}
                                                            {
                                                                base64 ?
                                                                    <Paper elevation={2}>
                                                                        <Image src={`data:image;base64,${base64}`} thumbnail style={{ width: 200, height: 120 }} />
                                                                    </Paper> :
                                                                    <Paper elevation={2}>
                                                                        <Image src={imgUrl[i]} thumbnail style={{ width: 200, height: 120 }} />
                                                                    </Paper>
                                                            }

                                                        </div>
                                                    )}
                                                </Dropzone>
                                            </div>
                                        )

                                }

                            }
                            return arr;
                        })()}
                    </Box>
                </Box>

                {/* {imageUploaded ?
                                                                <Paper elevation={3}>
                                                                    <Image src={front_imageId.url} style={{ width: 200, height: 120 }} />
                                                                </Paper> : <Paper elevation={3}>
                                                                    <Image src={userData.identity_front.small} thumbnail style={{ width: 200, height: 120 }} />
                                                                </Paper>} */}
                {/* </Grid>
                                                    </Grid>
                                                    </Grid> */}
            </Card>
        </React.Fragment>


    );
}


const AddProfileImage = ({ title, handleDropRejected, handleDrop, userData, imageUploaded, front_imageId, noOfUpload = 1, onlyAdd = false }) => {
    return (
        <React.Fragment>
            {(() => {
                const arr = [];
                for (let i = 0; i < noOfUpload; i++) {
                    arr.push(
                        <div style={{ position: "absolute", top: "130px", left: "75px" }}>
                            <Dropzone
                                onDrop={handleDrop}
                                accept="image/jpeg,image/jpg,image/png"
                                multiple={true}
                                maxSize={10485760}
                                onDropRejected={handleDropRejected}
                            >
                                {({ getRootProps, getInputProps }) => (
                                    <div {...getRootProps()}>
                                        <input {...getInputProps()} />
                                        <img src={uploadIcon} style={{ height: "25px" }} />

                                    </div>
                                )}
                            </Dropzone>
                        </div>
                    );
                }
                return arr;
            })()}
        </React.Fragment>
    );
}

const handleDropRejected = (...args) => console.log('reject', args);
export class InitialBasicCustomerProfile extends Component {

    constructor() {
        super();

        this.state = {
            fbLink: '',
            twLink: '',
            ytLink: '',
            instaLink: '',
            business_name: '',
            policy_number: '',
            contractor_number: '',
            est_date: '',
            exp_date: '',
            business_description: '',
            insurance_company_name: '',
            bank_name: '',
            bankError: '',
            account_holder_name: '',
            account_holder_nameerror: '',
            account_number: '',
            confirm_account_number: '',
            account_numbererror: '',
            rtn: '',
            rtnerror: '',
            showIdentity: false,
            provider_Type: '',
            crop: {
                aspect: 1 / 1
            },
            profile_image: store.getState().auth.userData.proImage.small,
            profileImagebase64Data: null,
            identity_frontbase64Data: null,
            identity_backbase64Data: null,
            address_frontbase64Data: null,
            address_backbase64Data: null,
            current_bondbase64Data: null,
            contractor_licensebase64Data: null,
            imageHash: Date.now(),
            front_imageId: [],
            back_imageId: [],
            front_imageAdd: [],
            back_imageAdd: [],
            current_bondAdd: [],
            certificates: [],
            userUploadedCertificates: [],
            imageUploaded: false,
            imageAddCurrentUploaded: false,
            imageIdBackUploaded: false,
            imageAddFrontUploaded: false,
            imageAddBackUploaded: false,
            isCertificateUploaded: false,
            showSubmitForReviewBtn: true,
            buttonLoader: false,
            buttonSaveLoader: false,
            dob: "",
            openDateTime: false,
            ssn: "",
            driver_license: "",
            isChecked: false,
            isAddress: false,
            errors: {
                bank_name: "",
                account_holder_name: "",
                rtn: "",
                account_number: "",
                confirm_account_number: '',
                ssn: ''
            },
            fields: {
                bank_name: "",
                account_holder_name: "",
                rtn: "",
                account_number: "",
                confirm_account_number: '',
                ssn: ''
            },
        }
        this.handleDrop = this.handleDrop.bind(this);
        this.handleProfilePicDrop = this.handleProfilePicDrop.bind(this);
        this.handleDropBack = this.handleDropBack.bind(this);
        this.handleFrontAddDrop = this.handleFrontAddDrop.bind(this);
        this.handleAddressDropBack = this.handleAddressDropBack.bind(this);
        this.handleCertificatDrop = this.handleCertificatDrop.bind(this);
        this.handleCurrentDropBack = this.handleCurrentDropBack.bind(this);
    }

    // validationSchema() {
    //     return Yup.object().shape({

    //       rtn: Yup.string()
    //         .required('Username is required')
    //         .min(6, 'Username must be at least 6 characters')
    //         .max(20, 'Username must not exceed 10 characters'),

    //         bank_name: Yup.string()
    //         .required('Bank Name is required')
    //         .min(6, 'Bank Name be at least 6 characters')
    //         .max(10, 'Bank Name must not exceed 20 characters'),

    //     });

    //   }
    //   handleSubmit(data) {
    //     console.log(JSON.stringify(data, null, 2));
    //   }

    // handleChange = () => {
    //     if(this.state.checked){
    //        this.setState({
    //       checked:false
    //     }); 
    //     }else{
    //         this.setState({
    //             checked:true
    //           }); 
    //     }

    //     // console.log("aaaa",panel)
    //   };
    toggleChange = () => {
        if (this.state.isChecked) {
            this.setState({
                isChecked: false
            })
        } else {
            this.setState({
                isChecked: true
            })
        }


    }


    validate = (name, value) => {
        switch (name) {
            case "bank_name":
                if (!value) {
                    return "Bank name is Required";
                    //  NotificationManager.error("Please fill Bank Details",);
                } else if (!value.match(/^[a-zA-Z-,]+(\s{0,1}[a-zA-Z-, ])*$/)) {
                    return "Please enter valid Bank Name";
                } else {
                    return "";
                }
            case "account_holder_name":
                if (!value) {
                    return "Account Holder Name is Required";
                } else if (!value.match(/^[a-zA-Z-,]+(\s{0,1}[a-zA-Z-, ])*$/)) {
                    return "Please enter valid Account Holder Name";
                } else {
                    return "";
                }

            case "rtn":
                if (!value) {
                    return "RTN is Required";
                }


                // else if (value.length < 9 ) {
                //     return "Please Enter minmum 9  number";
                // }

                // else if (value.length > 9) {
                //     return "Please insert valid RTN Number";
                // }


                //  else if(value.match(/[&\/\\#,+()$~%.'":*?<>{}]/g)){
                //     return "Please enter valid RTN";
                // } 


                else if (value.match(/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/)) {
                    return "Please enter valid  RTN";
                }


                else {
                    return "";
                }

            case "account_number":
                if (!value) {
                    return "Account Number is Required";
                    // } else if (value.length < 20) {
                    // return "Please Enter minmum 20 Number ";
                    // } 
                }

                // else if ( value.length > 9) {
                //     return "Please insert valid Account Number";
                //     }
                // else if (!value.match(/[a-z]/g)) {
                // return "Please enter at least lower character.";
                // } else if (!value.match(/[A-Z]/g)) {
                // return "Please enter at least upper character.";
                // } 
                // else if (!value.match(/[0-9]/g)) {
                // return "Please enter at least one digit.";
                // } 

                // else if(!value.match(/[0-10]/g)){
                //     return "Please enter valid Account Number";
                // }



                else if (value.match(/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/)) {
                    return "Please enter valid Account Number";
                }


                // else if(value.match(/[-]/g)){
                //     return "Please enter valid  Account Number";
                // } 




                else {
                    return "";
                }

            case "ssn":
                if (!value) {
                    // NotificationManager.error("Please Entar SSN Number",);
                    return "SSN is Required";
                } else if (value.length > 9) {
                    return "Please insert valid SSN Number ";
                }


                else if (value.length > 9) {
                    return "Please insert valid SSN Number";
                }
                // else if (!value.match(/[a-z]/g)) {
                // return "Please enter at least lower character.";
                // } else if (!value.match(/[A-Z]/g)) {
                // return "Please enter at least upper character.";
                // } 
                else if (!value.match(/[0-9]/g)) {
                    return "Please enter at least one digit.";
                } else {
                    return "";
                }
            default: {
                return "";
            }
        }
    }

    // handleUserInput = e => {
    //     this.setState({
    //       errors: {
    //         ...this.state.errors,
    //         [e.target.name]: this.validate(e.target.name, e.target.value)
    //       },
    //       fields: {
    //         ...this.state.fields,
    //         [e.target.name]: e.target.value
    //       },
    //       rtn: e.target.value,
    //       account_number: e.target.value,
    //     });
    //   };   
    handleSubmit = e => {
        const { error } = this.state;
        // e.preventDefault();
        let validationErrors = {};
        Object.keys(this.state).forEach(name => {
            const error = this.validate(name, this.state[name]);
            if (error && error.length > 0) {
                validationErrors[name] = error;

            }
        });
        if (Object.keys(validationErrors).length > 0) {
            this.setState({ errors: validationErrors });

            NotificationManager.error(
                "Please Enter  Bank and SSN  Details",
            );
            return;
        }
        // if (this.state.rtn && this.state.bank_name && this.state.account_number && this.state.account_holder_name && this.state.ssn) {
        //     const data = {
        //         rtn: this.state.rtn,
        //         account_holder_name: this.state.account_holder_name,
        //         account_number: this.state.account_number,
        //         bank_name: this.state.bank_name,
        //         ssn: this.state.ssn,
        //     };
        //     // this.updateProfile();
        //     // window.alert("subit success", JSON.stringify(data));
        //     console.log("----data----", data);
        // }

    };


    getData = () => {
        console.log("Inside GetData certifications", this.props.userData.certifications)
        console.log("Inside GetData certifications", this.props.userData)
        const { userData } = this.props;
        this.setState({
            fbLink: userData.fb_link,
            twLink: userData.twitter_link,
            ytLink: userData.youtube_link,
            instaLink: userData.insta_link,
            business_name: userData.businessName,
            policy_number: userData.policy_no,
            contractor_number: userData.contractor_no,
            est_date: userData.establishedOn,
            exp_date: userData.expiry_date,
            business_description: userData.description,
            insurance_company_name: userData.insurance_company_name,
            bank_name: userData.bank_name,
            account_holder_name: userData.account_holder_name,
            account_number: userData.account_number,
            confirm_account_number: userData.account_number,
            rtn: userData.rtn,
            provider_Type: userData.account_type,
            userUploadedCertificates: userData.certifications,
            dob: userData.dob,
            ssn: userData.ssn,
            driver_license: userData.driver_license

        })
    }
    componentDidMount() {
        this.getData()
        this.onAddressCheck()

    }


    handleProfilePicDrop(files) {
        console.warn(files)
        const file = files[0]
        if (file) {
            const reader = new FileReader();
            reader.onload = this._handleReaderLoaded.bind(this);
            reader.readAsBinaryString(file);
        }
        var fData = new FormData()
        fData.append('attribute', "logo");
        fData.append('image', files[0])
        this.props.idActionUpload(
            fData,
            this.onProfilePicDone
        )
    }


    onProfilePicDone = (success, data) => {
        console.log("success, data,files", success, data)
        if (success) {
            console.log(data.data, 'image upload')
            this.setState({
                profile_image: data.data.url,
                imageUploaded: true
            }, () => {
                NotificationManager.success("Success", data.message)

            })
        } else {
            this.setState({
                imageUploaded: false
            })
            NotificationManager.error("Oops!", data)
        }
    }

    handleDrop(files) {
        const file = files[0]
        console.info("imagedata", files[0].path)
        if (file) {
            const reader = new FileReader();
            reader.onload = this._handleReaderLoadedidentity_front.bind(this);
            reader.readAsBinaryString(file);
        }
        var fData = new FormData()
        fData.append('attribute', "identity_front");
        fData.append('image', files[0])
        console.info(fData)
        this.props.idActionUpload(
            fData,
            this.onFrontIdDone
        )
    }

    onFrontIdDone = (success, data) => {
        console.log("success, data,files", success, data)
        if (success) {
            console.log(data.data, 'image upload')
            this.setState({
                front_imageId: data.data,
                imageUploaded: true
            }, () => {
                NotificationManager.success("Success", data.message)
            })
        } else {
            this.setState({
                front_imageId: [],
                imageUploaded: false
            })
            NotificationManager.error("Oops!", data)
        }
    }

    handleDropBack(files) {
        const file = files[0]
        if (file) {
            const reader = new FileReader();
            reader.onload = this._handleReaderLoadedidentity_back.bind(this);
            reader.readAsBinaryString(file);
        }
        var fData = new FormData()
        fData.append('attribute', "identity_back");
        fData.append('image', files[0])
        this.props.idActionUpload(
            fData,
            this.onBackIdDone
        )
    }

    onBackIdDone = (success, data) => {
        console.log("success, data,files", success, data)
        if (success) {
            this.setState({
                back_imageId: data.data,
                imageIdBackUploaded: true
            }, () => {
                NotificationManager.success("Success", data.message)
            })
        } else {
            this.setState({
                back_imageId: [],
                imageIdBackUploaded: false
            })
            NotificationManager.error("Oops!", data)
        }
    }


    handleFrontAddDrop(files) {
        const file = files[0]
        if (file) {
            const reader = new FileReader();
            reader.onload = this._handleReaderLoadedaddress_front.bind(this);
            reader.readAsBinaryString(file);
        }
        var fData = new FormData()
        fData.append('attribute', "address_front");
        fData.append('image', files[0])
        this.props.idActionUpload(
            fData,
            this.onFrontAddDone
        )
    }

    onFrontAddDone = (success, data) => {
        console.log("success, data,files", success, data)
        if (success) {
            this.setState({
                front_imageAdd: data.data,
                imageAddFrontUploaded: true
            }, () => {
                NotificationManager.success("Success", data.message)
            })
        } else {
            this.setState({
                front_imageAdd: [],
                imageAddFrontUploaded: false
            })
            NotificationManager.error("Oops!", data)
        }
    }


    handleAddressDropBack(files) {
        const file = files[0]
        if (file) {
            const reader = new FileReader();
            reader.onload = this._handleReaderLoadedaddress_back.bind(this);
            reader.readAsBinaryString(file);
        }
        var fData = new FormData()
        fData.append('attribute', "address_back");
        fData.append('image', files[0])
        this.props.idActionUpload(
            fData,
            this.onBackAddDone
        )

    }

    onCurrentAddDone = (success, data) => {
        console.log("success, data,files ", success, data)
        if (success) {
            this.setState({
                current_bondAdd: data.data,
                imageAddCurrentUploaded: true
            }, () => {
                NotificationManager.success("Success", data.message)
            })
        } else {
            this.setState({
                current_bondAdd: [],
                imageAddCurrentUploaded: false
            })
            NotificationManager.error("Oops!", data)
        }
    }
    handleCurrentDropBack(files) {
        const file = files[0]
        if (file) {
            const reader = new FileReader();
            reader.onload = this._handleReaderLoadedcurrent_bond.bind(this);
            reader.readAsBinaryString(file);
        }
        console.log("handleCurrentDropBack", files)
        var fData = new FormData()
        fData.append('attribute', "current_bond");
        fData.append('image', files[0])


        this.props.idActionUpload(fData, this.onCurrentAddDone)



    }

    onBackAddDone = (success, data) => {
        console.log("success, data,files", success, data)
        if (success) {
            this.setState({
                back_imageAdd: data.data,
                imageAddBackUploaded: true
            }, () => {
                NotificationManager.success("Success", data.message)
            })
        } else {
            this.setState({
                back_imageAdd: [],
                imageAddBackUploaded: false
            })
            NotificationManager.error("Oops!", data)
        }
    }

    handleCertificatDrop(files) {
        this.setState({
            certificates: this.state.certificates.concat(
                files.map(file =>
                    Object.assign(file, {
                        preview: URL.createObjectURL(file),
                    }))
            )
        })
        const file = files[0]
        if (file) {
            const reader = new FileReader();
            reader.onload = this._handleReaderLoadedcontractor_license.bind(this);
            reader.readAsBinaryString(file);
        }
        var fData = new FormData()
        fData.append('attribute', "business_images");
        fData.append('image', files[0])
        this.props.idActionUpload(
            fData,
            this.onCertificateAdded
        )
    }

    onCertificateAdded = (success, data) => {
        console.log("success, data,files", success, data)
        if (success) {
            NotificationManager.success("Success", data.message)
            var newImageItem = {
                'small': data.data.url,
                'medium': data.data.url,
                'large': data.data.url,
            }
            this.setState({
                userUploadedCertificates: [...this.state.userUploadedCertificates, newImageItem],
                certificates: []
            })
        } else {
            NotificationManager.error("Oops!", data)
            this.setState({
                certificates: []
            })
        }
    }

    removeImage = (uri) => {
        var authToken = getCookies();
        Axios({
            method: 'post', //you can set what request you want to be
            url: `${SERVER_URL}/provider/remove-certification`,
            headers: {
                'x-auth-Token': authToken
            },
            data: { url: uri },
        }).then((response) => {
            if (response.data.status == 'OK') {
                NotificationManager.success("Success", response.data.message)
                var newUserCertificates = this.state.userUploadedCertificates.filter(image => image.small !== uri);
                this.setState({ userUploadedCertificates: newUserCertificates })
            } else {
                NotificationManager.error("Oops!", response.data.message)
            }
        })
    }

    _handleReaderLoaded = e => {
        console.log("file uploaded 2: ", e);
        let binaryString = e.target.result;
        this.setState({
            profileImagebase64Data: btoa(binaryString)
        });
    };

    _handleReaderLoadedidentity_front = e => {
        console.log("file uploaded 2: ", e);
        let binaryString = e.target.result;
        this.setState({
            identity_frontbase64Data: btoa(binaryString)
        });
    };

    _handleReaderLoadedidentity_back = e => {
        console.log("file uploaded 2: ", e);
        let binaryString = e.target.result;
        this.setState({
            identity_backbase64Data: btoa(binaryString)
        });
    };

    _handleReaderLoadedaddress_front = e => {
        console.log("file uploaded 2: ", e);
        let binaryString = e.target.result;
        this.setState({
            address_frontbase64Data: btoa(binaryString)
        });
    };

    _handleReaderLoadedaddress_back = e => {
        console.log("file uploaded 2: ", e);
        let binaryString = e.target.result;
        this.setState({
            address_backbase64Data: btoa(binaryString)
        });
    };

    _handleReaderLoadedcurrent_bond = e => {
        console.log("file uploaded 2: ", e);
        let binaryString = e.target.result;
        this.setState({
            current_bondbase64Data: btoa(binaryString)
        });
    };

    _handleReaderLoadedcontractor_license = e => {
        console.log("file uploaded 2: ", e);
        let binaryString = e.target.result;
        this.setState({
            contractor_licensebase64Data: btoa(binaryString)
        });
    };

    updateSocialMedia = () => {
        this.setState({
            buttonSaveLoader: false
        }
        );

        var authToken = getCookies();
        Axios({
            method: 'post',
            data: {
                // is_website: "yes",
                // bank_name: this.state.bank_name,
                // account_holder_name: this.state.account_holder_name,
                // account_number: this.state.account_number,
                // rtn: this.state.rtn,
                fb_link: this.state.fbLink,
                twitter_link: this.state.twLink,
                insta_link: this.state.instaLink,
                youtube_link: this.state.ytLink,
                // dob: this.state.dob,
                // ssn: this.state.ssn,
                // driver_license: this.state.driver_license

            },
            url: `${SERVER_URL}/provider/update-profile`,
            headers: { 'x-auth-token': authToken }
        }).then(resJson => {
            console.log("daataa", this.state.dob)
            if (resJson.data.status == "OK") {

                console.log("daataaddddddddddddddddd", this.state.dob)
                NotificationManager.success("Success", "Social Media details saved successfully")
                this.props.getLoggedInUserAction();
                // this.onProfileStatus();
                this.setState({
                    buttonSaveLoader: false
                })

            } else {
                NotificationManager.error("Oops!", resJson.data.message)
                this.setState({
                    buttonSaveLoader: false

                })

            }
        })
    }






    updateValidStateAndSSN = () => {
        this.setState({
            buttonSaveLoader: false
        }
        );
        if (this.state.dob === "") {
            NotificationManager.error("Date of birth is required")
        } else if (this.state.ssn === "") {
            NotificationManager.error("SSN is required")
        } else if (this.state.ssn.length !== 11) {
            NotificationManager.error("Please insert valid SSN Number")
        }
        else if (this.state.driver_license === "") {
            NotificationManager.error("Driver License Number is required")
        } else {
            var authToken = getCookies();
            Axios({
                method: 'post',
                data: {
                    // is_website: "yes",
                    // bank_name: this.state.bank_name,
                    // account_holder_name: this.state.account_holder_name,
                    // account_number: this.state.account_number,
                    // rtn: this.state.rtn,
                    // fb_link: this.state.fbLink,
                    // twitter_link: this.state.twLink,
                    // insta_link: this.state.instaLink,
                    // youtube_link: this.state.ytLink,
                    dob: this.state.dob,
                    ssn: this.state.ssn,
                    driver_license: this.state.driver_license

                },
                url: `${SERVER_URL}/provider/update-profile`,
                headers: { 'x-auth-token': authToken }
            }).then(resJson => {
                console.log("daataa", this.state.dob)
                if (resJson.data.status == "OK") {

                    console.log("daataaddddddddddddddddd", this.state.dob)
                    NotificationManager.success("Success", "ID details saved successfully")
                    this.props.getLoggedInUserAction();
                    // this.onProfileStatus();
                    this.setState({
                        buttonSaveLoader: false
                    })

                } else {
                    NotificationManager.error("Oops!", resJson.data.message)
                    this.setState({
                        buttonSaveLoader: false

                    })

                }
            })
        }

        // this.bankvalidation();
        // this.validationfrom();

    }

    updateBankDetails = () => {
        this.setState({
            buttonSaveLoader: false
        }
        );
        if (this.state.bank_name === "") {
            NotificationManager.error("Please Enter Bank Name")
        } else if (this.state.account_holder_name === "") {
            NotificationManager.error("Please Enter Account Holder's Name")
        } else if (this.state.account_number === "") {
            NotificationManager.error("Please Enter Account Number")
        } else if (this.state.confirm_account_number === "") {
            NotificationManager.error("Please Enter Confirm Account Number")
        } else if (this.state.rtn === "") {
            NotificationManager.error("Please Enter RTN Number")
        } else if (this.state.rtn.length !== 9) {
            NotificationManager.error("Please enter valid  RTN")
        }
        else if (this.state.account_number !== this.state.confirm_account_number) {
            NotificationManager.error("Account Number not matching")
        }
        else {
            var authToken = getCookies();
            Axios({
                method: 'post',
                data: {
                    // is_website: "yes",
                    bank_name: this.state.bank_name,
                    account_holder_name: this.state.account_holder_name,
                    account_number: this.state.account_number,
                    rtn: this.state.rtn
                    // fb_link: this.state.fbLink,
                    // twitter_link: this.state.twLink,
                    // insta_link: this.state.instaLink,
                    // youtube_link: this.state.ytLink,
                    // dob: this.state.dob,
                    // ssn: this.state.ssn,
                    // driver_license: this.state.driver_license

                },
                url: `${SERVER_URL}/provider/update-profile`,
                headers: { 'x-auth-token': authToken }
            }).then(resJson => {
                console.log("daataa", this.state.dob)
                if (resJson.data.status == "OK") {

                    console.log("daataaddddddddddddddddd", this.state.dob)
                    NotificationManager.success("Success", 'Bank details saved successfully')
                    this.props.getLoggedInUserAction();
                    // this.onProfileStatus();
                    this.setState({
                        buttonSaveLoader: false
                    })

                } else {
                    NotificationManager.error("Oops!", resJson.data.message)
                    this.setState({
                        buttonSaveLoader: false

                    })

                }
            })
        }

        // this.bankvalidation();
        // this.validationfrom();

    }


    updateAboutBusiness = () => {
        this.setState({
            buttonSaveLoader: false
        }
        );
        console.warn(this.state.exp_date)
        if (this.state.est_date === "") {
            NotificationManager.error("Please Enter Established On")
        } else if (this.state.policy_number === "") {
            NotificationManager.error("Please Enter Policy Number")
        } else if (this.state.contractor_number === "") {
            NotificationManager.error("Please Enter Contractor Number")
        } else if (this.state.insurance_company_name === "") {
            NotificationManager.error("Please Enter Insurance Company Name")
        }
        else if (this.state.exp_date == "" || !this.state.exp_date) {
            NotificationManager.error("Please Enter Date of Expiration")
        } else if (this.state.business_description === "") {
            NotificationManager.error("Please Enter Description")
        }
        else {
            var authToken = getCookies();
            Axios({
                method: 'post',
                data: {
                    establishedOn: this.state.est_date,
                    insurance_company_name: this.state.insurance_company_name.toUpperCase(),
                    policy_no: this.state.policy_number.toUpperCase(),
                    contractor_no: this.state.contractor_number.toUpperCase(),
                    expiry_date: this.state.exp_date,
                    description: this.state.business_description

                },
                url: `${SERVER_URL}/provider/update-profile`,
                headers: { 'x-auth-token': authToken }
            }).then(resJson => {
                console.log("daataa", this.state.dob)
                if (resJson.data.status == "OK") {

                    console.log("daataaddddddddddddddddd", this.state.dob)
                    NotificationManager.success("Success", 'Business details saved successfully')
                    this.props.getLoggedInUserAction();
                    // this.onProfileStatus();
                    this.setState({
                        buttonSaveLoader: false
                    })

                } else {
                    NotificationManager.error("Oops!", resJson.data.message)
                    this.setState({
                        buttonSaveLoader: false

                    })

                }
            })
        }

        // this.bankvalidation();
        // this.validationfrom();

    }

    onProfileStatus = () => {
        this.setState({
            buttonLoader: true
        })

        if (this.state.isChecked === false) {
            NotificationManager.error("Oops!", "Please accept Terms and Conditions")
        } else {
            var authToken = getCookies();
            Axios({
                method: 'get',
                url: `${SERVER_URL}/profile/submit`,
                headers: {
                    'x-auth-Token': authToken
                },
            }).then(async (Response) => {
                // console.log('Profile status response========a', Response, Response.data.status)
                if (Response.data.status == 'OK') {
                    NotificationManager.success("Success", Response.data.message)
                    const response = await this.props.getLoggedInUserAction();
                    if (response) {
                        this.setState({
                            buttonLoader: false
                        })
                    } else {
                        this.setState({
                            buttonLoader: false
                        })
                    }

                } else {
                    NotificationManager.error("Oops!", Response.data.message)
                    this.setState({
                        buttonLoader: false
                    })
                }
            })
        }


        // this.bankvalidation();
    }

    onAddressCheck = () => {

        var authToken = getCookies();
        Axios({
            method: 'get',
            url: `${SERVER_URL}/user-address/list`,
            headers: {
                'x-auth-Token': authToken
            },
        }).then(async (Response) => {
            // console.log('Profile status response========a', Response, Response.data.status)
            if (Response.data.message == 'No address found' || Response.data.status == 'NOK') {
                this.setState({
                    isAddress: false
                })

            } else {
                this.setState({
                    isAddress: true
                })
            }
        })



        // this.bankvalidation();
    }
    // onFromChangeDate = event => {
    //     console.log("date event::::::::", event)
    //     const dateTimeValue = moment(event).format('MM/DD/YYYY');
    //     this.setState({ dob: dateTimeValue, openDateTime: false})

    // const date = '12/05/2001';   // Your date
    // const format = 'MM/DD/YYYY'; // Your date format
    // const resultFormat = 'years' // Result format (years, months, days)


    // const years = moment().diff(moment("1981-01-01", 'years',false));
    // console.log("date",years)

    // if (years >= 18){
    //     alert('Do what u want');
    //     this.setState({ dob: dateTimeValue, openDateTime: false})
    // } else {
    //     alert('Come back later');
    // }
    // }

    // };
    onFromChangeDate = event => {
        const dateTimeValue = moment(event).format('MM/DD/YYYY');
        this.setState({ dob: dateTimeValue, openDateTime: false })
        // const age = moment().diff(moment(dateTimeValue), 'years');
        // if(age < 18){   
        // alert('You are under age. Minimum age should be 18 yrs');
        // return 
        // }
        // else{
        //    return 
        // }
    }
    onFromChangeDateEst = event => {
        const dateTimeValue = moment(event).format('MM/DD/YYYY');
        this.setState({ est_date: dateTimeValue, openDateTime: false })
    }

    onFromChangeDateExp = event => {
        const dateTimeValue = moment(event).format('MM/DD/YYYY');
        this.setState({ exp_date: dateTimeValue, openDateTime: false })
    }

    changeNum(num) {
        var formatNum = num.replace(/(\d{3})(\d{2})(\d{4})/, '$1-$2-$3');
        this.setState({
            ssn: formatNum
        }, console.log("number", formatNum));
    }

    render() {
        console.warn(this.state.exp_date)
        console.log(this.props, 'props in initialbasicCP')
        console.log(this.props.userData, 'userData for underRevive  in initialbasicCP')
        const { anchorEl, mobileMoreAnchorEl, anchorE2 } = this.state;
        // const { classes, userData } = this.props;
        const isMenuOpen = Boolean(anchorEl);
        // const isNotiMenuOpen = Boolean(anchorE2);
        const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
        var fromMax = moment().add(0, 'day')

        var valid = function (current) {

            return (fromMax >= current);
        };

        var yesterday = moment().subtract(1, 'day');
        var validexdate = function (current) {

            return current.isAfter(yesterday);
        };

        const { bankError,
            rtnerror,
            account_holder_nameerror,
            account_numbererror, formErrors } = this.state;
        const { userData } = this.props;
        const { fields, errors } = this.state;
        const initialValues = {
            rtn: '',
        };
        console.warn(this.state.isAddress)
    // const { expanded } = this.state;
        /* console.log("user data account type ----------", userData.account_type) */4
        return (
            <HOCLoader loading={this.props.isLoading}>
                <div className="text-center arab-table tz-db-table">

                    <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', columnGap: 3 }}>
                        <IconButton
                            className="btn-profile"
                            style={{ maxWidth: '30%' }}
                            aria-owns={
                                isMenuOpen
                                    ? 'material-appbar'
                                    : undefined
                            }
                            aria-haspopup="true"
                            onClick={
                                () => {
                                    this.setState({
                                        zoomImageModal: true,
                                        zoomSrc: store.getState().auth.userData
                                            .role == ROLE_CUSTOMER ? store.getState()
                                                .auth
                                                .userData
                                                .image
                                            .medium : store.getState()
                                                .auth
                                                .userData
                                                .proImage
                                            .medium
                                    })
                                }
                            }
                            color="inherit"
                        >
                            {store.getState().auth.userData
                                .role == ROLE_CUSTOMER
                                ? (
                                    <Avatar
                                        alt="User Profile"
                                        src={this.state.profileImagebase64Data ?
                                            `data:image;base64,${this.state.profileImagebase64Data}`
                                            :
                                            // store.getState()
                                            //     .auth
                                            //     .userData
                                            //     .image
                                            //     .small
                                            this.state.profile_image
                                        }

                                        className="hide-md"

                                    />
                                )
                                : (
                                    <Avatar
                                        alt="User Profile"
                                        src={this.state.profileImagebase64Data ?

                                            `data:image;base64,${this.state.profileImagebase64Data}`

                                            :
                                            // store.getState()
                                            //     .auth
                                            //     .userData
                                            //     .proImage
                                            //     .small
                                            this.state.profile_image
                                        }

                                        className="hide-md"

                                    />
                                )}
                            <AddProfileImage
                                handleDrop={this.handleProfilePicDrop}
                                handleDropRejected={handleDropRejected}
                                userData={userData}
                                state={this.state}
                                imageUploaded={this.state.imageUploaded}
                                // front_imageId={this.state.front_imageId}
                                noOfUpload={1}
                            />
                        </IconButton>


                        <Box sx={{ display: 'flex', flexDirection: 'column', }}>
                            <Table className=" ">
                                <TableBody>
                                    <TableRow style={{ border: 0, height: '35px' }}>
                                        {userData.role == ROLE_PROVIDER && userData.account_type == 1 ?
                                            <TableCell style={{ padding: "0 14px 0 0" }} className="text-left">
                                                Freelancer
                                            </TableCell>
                                            :
                                            <React.Fragment>
                                                <TableCell style={{ padding: "0 14px 0 0" }} className="text-left">
                                                    <FormattedMessage
                                                        id="business"
                                                        defaultMessage={userData.role == ROLE_PROVIDER ? userData.account_type == 2 ?
                                                            'Business Name' :
                                                            (userData.account_type == 1 ? (
                                                                'Freelancer'
                                                            ) : '') : ''
                                                        }
                                                    />
                                                    :
                                                </TableCell>
                                                <TableCell style={{ padding: "0 14px 0 0" }} className="text-left">
                                                    {userData.businessName}
                                                </TableCell>
                                            </React.Fragment>
                                        }

                                    </TableRow>

                                    <TableRow style={{ height: "35px" }} >
                                        <TableCell style={{ padding: "0 14px 0 0" }} className="text-left">
                                            <FormattedMessage
                                                id="email"
                                                defaultMessage="Email"
                                            />
                                            :
                                        </TableCell>
                                        <TableCell style={{ padding: "0 14px 0 0" }} className="text-left">
                                            {userData.email}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow style={{ height: "35px" }} >
                                        <TableCell style={{ padding: "0 14px 0 0" }} className="text-left">
                                            <FormattedMessage
                                                id="phone"
                                                defaultMessage="Phone"
                                            />{' '}
                                            :
                                        </TableCell>
                                        <TableCell style={{ padding: "0 14px 0 0" }} className="text-left">
                                            {userData.phone}
                                        </TableCell>
                                    </TableRow>
                                    {/* <TableRow>
                                        <TableCell className="text-left">
                                            <FormattedMessage
                                                id="status"
                                                defaultMessage="Status"
                                            />
                                            :
                                        </TableCell>
                                        <TableCell className="text-left" style={{ fontWeight: 'bold' }}>
                                            {getStatus(userData.status)}
                                        </TableCell>
                                    </TableRow> */}
                                    {/* <TableRow>
                                        <TableCell className="text-left">
                                            <FormattedMessage
                                                id="createdAt"
                                                defaultMessage="Created At"
                                            />
                                            :
                                </TableCell>
                                        <TableCell className="text-left">
                                            {moment(userData.created_at).format(
                                                'MM-DD-YYYY hh:mm:ss a'
                                            )}
                                        </TableCell>
                                    </TableRow> */}
                                </TableBody>
                            </Table>
                        </Box>
                    </Box>

                    {userData.role == ROLE_PROVIDER && userData.under_review === 2 && userData.show_underreview === false && <div className="d-flex justify-content-center p-2 md-12" style={{
                        borderWidth: 1, borderStyle: "solid", borderColor: "#dddddd", height: 50,
                        alignItems: "center"
                    }}>
                        <div style={{ display: "flex", flexDirection: "column" }} >
                            <Typography style={{ fontWeight: "bold", color: "#4e784f", fontSize: "13px", marginBottom: "4px" }} >Hello, {userData.name}</Typography>
                            <Typography style={{ fontWeight: "bold", color: 'blue', fontSize: "15px" }} >Profile Status - In Progress</Typography>
                        </div>
                    </div>}
                    {userData.role == ROLE_PROVIDER && userData.show_underreview && <div className="d-flex justify-content-center p-2 md-12" style={{
                        borderWidth: 1, borderStyle: "solid", borderColor: "#dddddd", height: 50,
                        alignItems: "center"
                    }}>
                        <div style={{ display: "flex", flexDirection: "column" }} >
                            <Typography style={{ fontWeight: "bold", color: "#4e784f", fontSize: "13px", marginBottom: "4px" }} >Hello, {userData.name}</Typography>
                            <Typography style={{ fontWeight: "bold", color: 'orange', fontSize: "15px" }} >Profile Status - Under Review</Typography>
                        </div>

                    </div>}
                    {userData.role == ROLE_PROVIDER && userData.review_status === false && <div className="d-flex justify-content-center p-2 md-12" style={{
                        borderWidth: 1, borderStyle: "solid", borderColor: "#dddddd", height: 50,
                        alignItems: "center"
                    }}>
                        <div style={{ display: "flex", flexDirection: "column" }} >
                            <Typography style={{ fontWeight: "bold", color: "#4e784f", fontSize: "13px", marginBottom: "4px" }} >Hello, {userData.name}</Typography>
                            <Typography style={{ fontWeight: "bold", color: "red", fontSize: "15px" }} >Profile Status - Rejected</Typography>
                        </div>

                    </div>}

                    {/* <ExpansionPanel defaultExpanded={userData.role != ROLE_PROVIDER}>
                        <ExpansionPanelSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Typography >Basic Info</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>

                            <Table className="table borderless">
                                <TableBody>
                                    <TableRow>
                                        <TableCell className="text-left">
                                            <FormattedMessage
                                                id="name"
                                                defaultMessage="Name"
                                            />
                                            :
                                </TableCell>
                                        <TableCell className="text-left">
                                            {userData.name}
                                        </TableCell>
                                    </TableRow>

                                    <TableRow>
                                        <TableCell className="text-left">
                                            <FormattedMessage
                                                id="email"
                                                defaultMessage="Email"
                                            />
                                            :
                                </TableCell>
                                        <TableCell className="text-left">
                                            {userData.email}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell className="text-left">
                                            <FormattedMessage
                                                id="phone"
                                                defaultMessage="Phone"
                                            />{' '}
                                            :
                                </TableCell>
                                        <TableCell className="text-left">
                                            {userData.phone}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell className="text-left">
                                            <FormattedMessage
                                                id="status"
                                                defaultMessage="Status"
                                            />
                                            :
                                </TableCell>
                                        <TableCell className="text-left">
                                            {getStatus(userData.status)}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell className="text-left">
                                            <FormattedMessage
                                                id="createdAt"
                                                defaultMessage="Created At"
                                            />
                                            :
                                </TableCell>
                                        <TableCell className="text-left">
                                            {moment(userData.created_at).format(
                                                'MM-DD-YYYY hh:mm:ss a'
                                            )}
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>

                        </ExpansionPanelDetails>
                    </ExpansionPanel> */}
                    {/** Basic Info end**/}

                    {/* {userData.role == ROLE_PROVIDER && (
                        <React.Fragment>

                            <ExpansionPanel>
                                <ExpansionPanelSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography >Additioanl User Info</Typography>
                                </ExpansionPanelSummary>
                                <ExpansionPanelDetails>
                                    <Table className="table bordered custom-input-text">
                                        <TableBody>
                                            <TableRow>
                                                <TableCell className="text-left">
                                                    <FormattedMessage
                                                        id="bank_name"
                                                        defaultMessage="Bank Name"
                                                    />
                                                    :
                                        </TableCell>
                                                <TableCell className="text-left">
                                                    <form className="form-new">
                                                        <TextField
                                                            className="login-form-textfield"
                                                            id="bank"
                                                            fullWidth={true}
                                                            name="bank"
                                                            placeholder={"Enter Bank Name"}
                                                            value={this.state.bank_name}
                                                            onChange={event => {
                                                                this.setState({
                                                                    bank_name: event.target.value,
                                                                });
                                                            }}
                                                            disabled={userData.disable_sensitive_info}

                                                        />
                                                    </form>

                                                </TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell className="text-left">
                                                    <FormattedMessage
                                                        id="account_holder_name"
                                                        defaultMessage="Account Holder Name"
                                                    />
                                                    :
                                        </TableCell>
                                                <TableCell className="text-left">
                                                    <form className="form-new">
                                                        <TextField
                                                            className="login-form-textfield"
                                                            id="accountholder"
                                                            fullWidth={true}
                                                            name="accountholder"
                                                            placeholder={"Enter Account Holder Name"}
                                                            value={this.state.account_holder_name}
                                                            onChange={event => {
                                                                this.setState({
                                                                    account_holder_name: event.target.value,
                                                                });
                                                            }}
                                                            disabled={userData.disable_sensitive_info}


                                                        />
                                                    </form>

                                                </TableCell>
                                            </TableRow>

                                            <TableRow>
                                                <TableCell className="text-left">
                                                    <FormattedMessage
                                                        id="account_number"
                                                        defaultMessage="Account Number"
                                                    />
                                                    :
                                        </TableCell>
                                                <TableCell className="text-left">
                                                    <form className="form-new">
                                                        <TextField
                                                            className="login-form-textfield"
                                                            id="accountnumber"
                                                            fullWidth={true}
                                                            name="accountnumber"
                                                            placeholder={"Enter Account Number"}
                                                            value={this.state.account_number}
                                                            onChange={event => {
                                                                this.setState({
                                                                    account_number: event.target.value,
                                                                });
                                                            }}
                                                            disabled={userData.disable_sensitive_info}

                                                        />
                                                    </form>

                                                </TableCell>
                                            </TableRow>

                                            <TableRow>
                                                <TableCell className="text-left">
                                                    <FormattedMessage
                                                        id="rtn"
                                                        defaultMessage="RTN"
                                                    />
                                                    :
                                        </TableCell>
                                                <TableCell className="text-left">
                                                    <form className="form-new">
                                                        <TextField
                                                            className="login-form-textfield"
                                                            id="rtn"
                                                            fullWidth={true}
                                                            name="rtn"
                                                            placeholder={"Enter RTN"}
                                                            value={this.state.rtn}
                                                            onChange={event => {
                                                                this.setState({
                                                                    rtn: event.target.value,
                                                                });
                                                            }}
                                                            disabled={userData.disable_sensitive_info}


                                                        />
                                                    </form>

                                                </TableCell>
                                            </TableRow>

                                        </TableBody>
                                    </Table>
                                </ExpansionPanelDetails>
                            </ExpansionPanel>
                        </React.Fragment>
                    )}
 */}
                    {userData.role == ROLE_PROVIDER && userData.account_type == 2 && (
                        <React.Fragment>

                            <ExpansionPanel>
                                <ExpansionPanelSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography >Add Address *</Typography>
                                </ExpansionPanelSummary>
                                <ExpansionPanelDetails style={{ display: "flex", flexDirection: "column" }} >
                                    {this.state.isAddress ?
                                        <Address />
                                        :
                                        <AddressCreate
                                            {...this.props}
                                        // {...sendProps(this.props)}
                                        />
                                    }
                                </ExpansionPanelDetails>
                            </ExpansionPanel>
                        </React.Fragment>
                    )}
                    {userData.role == ROLE_PROVIDER && userData.account_type == 2 && (
                        <React.Fragment>

                            <ExpansionPanel>
                                <ExpansionPanelSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography >Training Center</Typography>
                                </ExpansionPanelSummary>
                                <ExpansionPanelDetails>
                                    <Box width='100%'>
                                        <ProviderTrainingCenter {...this.props} />
                                    </Box>
                                </ExpansionPanelDetails>
                            </ExpansionPanel>
                        </React.Fragment>
                    )}
                    {userData.role == ROLE_PROVIDER && userData.account_type == 2 && (
                        <React.Fragment>

                            <ExpansionPanel>
                                <ExpansionPanelSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography >Working Days & Hours</Typography>
                                </ExpansionPanelSummary>
                                <ExpansionPanelDetails>
                                    <Box width='100%'>
                                        <ProviderBusinessHours {...this.props} />
                                    </Box>
                                </ExpansionPanelDetails>
                            </ExpansionPanel>
                        </React.Fragment>
                    )}




                    {userData.role == ROLE_PROVIDER && (
                        <React.Fragment>
                            <ExpansionPanel>
                                <ExpansionPanelSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography >Social Media</Typography>
                                </ExpansionPanelSummary>
                                <ExpansionPanelDetails>
                                    <Box width='100%'>
                                        <Table className="table bordered custom-input-text">
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell className="text-left">
                                                        <FormattedMessage
                                                            id="fb_link"
                                                            defaultMessage="Facebook Link"
                                                        />
                                                        :
                                                    </TableCell>
                                                    <TableCell className="text-left">
                                                        <form className="form-new">
                                                            <TextField
                                                                className="login-form-textfield"
                                                                id="facebook"
                                                                label="Facebook"

                                                                fullWidth={true}
                                                                name="facebook"
                                                                placeholder={"Enter facebook link"}
                                                                value={this.state.fbLink}
                                                                onChange={event => {
                                                                    this.setState({
                                                                        fbLink: event.target.value,
                                                                    });
                                                                }}
                                                            />
                                                        </form>

                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell className="text-left">
                                                        <FormattedMessage
                                                            id="twitter_link"
                                                            defaultMessage="Twitter Link"
                                                        />
                                                        :
                                                    </TableCell>
                                                    <TableCell className="text-left">
                                                        <form className="form-new">
                                                            <TextField
                                                                className="login-form-textfield"
                                                                id="twitter"
                                                                fullWidth={true}
                                                                label="Twitter"

                                                                name="twitter"
                                                                placeholder={"Enter twitter link"}
                                                                value={this.state.twLink}
                                                                onChange={event => {
                                                                    this.setState({
                                                                        twLink: event.target.value,
                                                                    });
                                                                }}
                                                            />
                                                        </form>
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell className="text-left">
                                                        <FormattedMessage
                                                            id="insta_link"
                                                            defaultMessage="Instagram Link"
                                                        />
                                                        :
                                                    </TableCell>
                                                    <TableCell>
                                                        <form className="form-new">
                                                            <TextField
                                                                className="login-form-textfield"
                                                                id="insta"
                                                                fullWidth={true}
                                                                name="insta"
                                                                label="Instagram"

                                                                placeholder={"Enter insta link"}
                                                                value={this.state.instaLink}
                                                                onChange={event => {
                                                                    this.setState({
                                                                        instaLink: event.target.value,
                                                                    });
                                                                }}
                                                            />
                                                        </form>
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell className="text-left">
                                                        <FormattedMessage
                                                            id="youtube_link"
                                                            defaultMessage="Youtube Link"
                                                        />
                                                        :
                                                    </TableCell>
                                                    <TableCell className="text-left">
                                                        <form className="form-new">
                                                            <TextField
                                                                className="login-form-textfield"
                                                                id="youtube"
                                                                label="Youtube"

                                                                fullWidth={true}
                                                                name="youtube"
                                                                placeholder={"Enter youtube link"}
                                                                value={this.state.ytLink}
                                                                onChange={event => {
                                                                    this.setState({
                                                                        ytLink: event.target.value,
                                                                    });
                                                                }}
                                                            />
                                                        </form>
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                            {/* <TableFooter>
                                        <TableCell colSpan="2">
                                            <div className="md-12 d-flex justify-content-center mt-1 mb-1">
                                                <Button variant="contained" color="primary"> Save</Button>
                                            </div>
                                            </TableCell>
                                        </TableFooter> */}
                                        </Table>
                                        <div className="col-md-12 d-flex" style={{
                                            justifyContent: "center", marginTop: '10px',
                                            marginBottom: '10px'
                                        }}>
                                            {this.state.buttonSaveLoader ? <CircularProgress /> :
                                                <React.Fragment>
                                                    {userData.role == ROLE_PROVIDER && userData.show_underreview ? null :

                                                        <button
                                                            className="custom-button"
                                                            onClick={() => this.updateSocialMedia()}
                                                        >
                                                            SAVE
                                                        </button>
                                                    }
                                                </React.Fragment>
                                            }
                                        </div>
                                    </Box>
                                </ExpansionPanelDetails>
                            </ExpansionPanel>
                        </React.Fragment>
                    )}
                    {/** Social profile end**/}

                    {userData.role == ROLE_PROVIDER && (
                        <React.Fragment>
                            <ExpansionPanel>
                                <ExpansionPanelSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography >Valid State ID or License *</Typography>
                                </ExpansionPanelSummary>
                                <ExpansionPanelDetails>
                                    <div>
                                        <Grid container xs={12}>
                                            <Grid container spacing={2} columnSpacing={2} rowSpacing={2}>
                                                <Grid item xs={12} lg={6}>
                                                    {userData.identity_front && (
                                                        <React.Fragment>
                                                            <React.Fragment>
                                                                <Card sx={{ width: '100%', p: 3, flex: 1, alignItems: 'center' }}>
                                                                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
                                                                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', }}>
                                                                            <Typography>Valid Driving License</Typography>
                                                                            <Typography style={{ color: '#a432a8' }}>{`(*Allowed file size is 10MB and supports only JPEG/PNG)`}</Typography>
                                                                        </Box>
                                                                        <div style={{ display: "flex" }} className='identity_box'>
                                                                            <Box sx={{ display: 'flex', alignItems: 'center', columnGap: 2, jutifyContent: 'center', pt: 2 }}>
                                                                                {
                                                                                    userData.identity_front.small.split("/")[3] === 'images' ?
                                                                                        <React.Fragment>
                                                                                            {this.state.identity_frontbase64Data ?
                                                                                                <div style={{ width: 150, height: 100, background: '#b2b2b3', pt: '20px', mx: 3 }}>
                                                                                                    {/* <p>Identity Front</p> */}
                                                                                                    <Dropzone
                                                                                                        onDrop={this.handleDrop}
                                                                                                        accept="image/jpeg,image/jpg,image/png"
                                                                                                        multiple={true}
                                                                                                        maxSize={10485760}
                                                                                                        onDropRejected={handleDropRejected}
                                                                                                    >
                                                                                                        {({ getRootProps, getInputProps }) => (
                                                                                                            <div {...getRootProps()}>
                                                                                                                <input {...getInputProps()} />
                                                                                                                <Paper elevation={2}>
                                                                                                                    <Image src={this.state.identity_frontbase64Data ?
                                                                                                                        `data:image;base64,${this.state.identity_frontbase64Data}` :
                                                                                                                        userData.identity_front.small} thumbnail style={{ width: 200, height: 120 }} />
                                                                                                                </Paper>
                                                                                                            </div>
                                                                                                        )}
                                                                                                    </Dropzone>
                                                                                                </div>
                                                                                                :
                                                                                                <div style={{ width: 150, height: 100, background: '#b2b2b3', pt: '20px', mx: 3 }}>
                                                                                                    {/* <p>Identity Front</p> */}
                                                                                                    <Dropzone
                                                                                                        onDrop={this.handleDrop}
                                                                                                        accept="image/jpeg,image/jpg,image/png"
                                                                                                        multiple={true}
                                                                                                        maxSize={10485760}
                                                                                                        onDropRejected={handleDropRejected}
                                                                                                    >
                                                                                                        {({ getRootProps, getInputProps }) => (
                                                                                                            <div {...getRootProps()}>
                                                                                                                <input {...getInputProps()} />
                                                                                                                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', pt: 3, color: '#717175' }}>
                                                                                                                    <Box > <AddIcon fontSize='large' /></Box>
                                                                                                                    <Typography style={{ color: '#717175' }}>
                                                                                                                        Front Photo
                                                                                                                    </Typography>
                                                                                                                </Box>
                                                                                                            </div>
                                                                                                        )}
                                                                                                    </Dropzone>
                                                                                                </div>

                                                                                            }
                                                                                        </React.Fragment>

                                                                                        :
                                                                                        <div style={{ width: 150, height: 100, background: '#b2b2b3', pt: '20px', mx: 3 }}>
                                                                                            {/* <p>Identity Front</p> */}
                                                                                            <Dropzone
                                                                                                onDrop={this.handleDrop}
                                                                                                accept="image/jpeg,image/jpg,image/png"
                                                                                                multiple={true}
                                                                                                maxSize={10485760}
                                                                                                onDropRejected={handleDropRejected}
                                                                                            >
                                                                                                {({ getRootProps, getInputProps }) => (
                                                                                                    <div {...getRootProps()}>
                                                                                                        <input {...getInputProps()} />
                                                                                                        <Paper elevation={2}>
                                                                                                            <Image src={this.state.identity_frontbase64Data ?
                                                                                                                `data:image;base64,${this.state.identity_frontbase64Data}` :
                                                                                                                userData.identity_front.small} thumbnail style={{ width: 200, height: 120 }} />
                                                                                                        </Paper>
                                                                                                    </div>
                                                                                                )}
                                                                                            </Dropzone>
                                                                                        </div>
                                                                                }

                                                                            </Box>
                                                                            {/* identity_back code start */}
                                                                            <Box sx={{ display: 'flex', alignItems: 'center', columnGap: 2, jutifyContent: 'center', pt: 2 }}>
                                                                                {
                                                                                    userData.identity_back.small.split("/")[3] === 'images' ?
                                                                                        <React.Fragment>
                                                                                            {
                                                                                                this.state.identity_backbase64Data ?
                                                                                                    <div style={{ width: 150, height: 100, background: '#b2b2b3', pt: '20px', mx: 3 }}>
                                                                                                        {/* <p>Identity Front</p> */}
                                                                                                        <Dropzone
                                                                                                            onDrop={this.handleDropBack}
                                                                                                            accept="image/jpeg,image/jpg,image/png"
                                                                                                            multiple={true}
                                                                                                            maxSize={10485760}
                                                                                                            onDropRejected={handleDropRejected}
                                                                                                        >
                                                                                                            {({ getRootProps, getInputProps }) => (
                                                                                                                <div {...getRootProps()}>
                                                                                                                    <input {...getInputProps()} />
                                                                                                                    <Paper elevation={2}>
                                                                                                                        <Image src={this.state.identity_backbase64Data ?
                                                                                                                            `data:image;base64,${this.state.identity_backbase64Data}` :
                                                                                                                            userData.identity_back.small} thumbnail style={{ width: 200, height: 120 }} />
                                                                                                                    </Paper>
                                                                                                                </div>
                                                                                                            )}
                                                                                                        </Dropzone>
                                                                                                    </div>
                                                                                                    :
                                                                                                    <div style={{ width: 150, height: 100, background: '#b2b2b3', pt: '20px', mx: 3 }}>
                                                                                                        {/* <p>Identity Front</p> */}
                                                                                                        <Dropzone
                                                                                                            onDrop={this.handleDropBack}
                                                                                                            accept="image/jpeg,image/jpg,image/png"
                                                                                                            multiple={true}
                                                                                                            maxSize={10485760}
                                                                                                            onDropRejected={handleDropRejected}
                                                                                                        >
                                                                                                            {({ getRootProps, getInputProps }) => (
                                                                                                                <div {...getRootProps()}>
                                                                                                                    <input {...getInputProps()} />
                                                                                                                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', pt: 3, color: '#717175' }}>
                                                                                                                        <Box > <AddIcon fontSize='large' /></Box>
                                                                                                                        <Typography style={{ color: '#717175' }}>
                                                                                                                            Back Photo
                                                                                                                        </Typography>
                                                                                                                    </Box>
                                                                                                                </div>
                                                                                                            )}
                                                                                                        </Dropzone>
                                                                                                    </div>

                                                                                            }
                                                                                        </React.Fragment>

                                                                                        :

                                                                                        <div style={{ width: 150, height: 100, background: '#b2b2b3', pt: '20px', mx: 3 }}>
                                                                                            {/* <p>Identity Front</p> */}
                                                                                            <Dropzone
                                                                                                onDrop={this.handleDropBack}
                                                                                                accept="image/jpeg,image/jpg,image/png"
                                                                                                multiple={true}
                                                                                                maxSize={10485760}
                                                                                                onDropRejected={handleDropRejected}
                                                                                            >
                                                                                                {({ getRootProps, getInputProps }) => (
                                                                                                    <div {...getRootProps()}>
                                                                                                        <input {...getInputProps()} />
                                                                                                        <Paper elevation={2}>
                                                                                                            <Image src={this.state.identity_backbase64Data ?
                                                                                                                `data:image;base64,${this.state.identity_backbase64Data}` :
                                                                                                                userData.identity_back.small} thumbnail style={{ width: 200, height: 120 }} />
                                                                                                        </Paper>
                                                                                                    </div>
                                                                                                )}
                                                                                            </Dropzone>
                                                                                        </div>
                                                                                }

                                                                            </Box>
                                                                        </div>
                                                                    </Box>

                                                                </Card>
                                                            </React.Fragment>
                                                        </React.Fragment>


                                                    )}
                                                </Grid>
                                                <Grid item xs={12} md={6}>
                                                    {userData.address_front && (<AddImagesBox
                                                        title='Proof of Business Address'
                                                        handleDrop={this.handleFrontAddDrop}
                                                        handleDropRejected={handleDropRejected}
                                                        userData={userData}
                                                        state={this.state}
                                                        imageUploaded={this.state.imageUploaded}
                                                        imageId={this.state.front_imageId}
                                                        imgUrl={[userData.address_front.small]}
                                                        base64={this.state.address_frontbase64Data}
                                                    />
                                                    )}
                                                </Grid>
                                                <Grid item xs={12} md={6}>
                                                    {userData.address_back && (<AddImagesBox
                                                        title='Current Insurance Certificate'
                                                        handleDrop={this.handleAddressDropBack}
                                                        handleDropRejected={handleDropRejected}
                                                        userData={userData}
                                                        state={this.state}
                                                        imageUploaded={this.state.imageUploaded}
                                                        front_imageId={this.state.front_imageId}
                                                        imgUrl={[userData.address_back.small]}
                                                        base64={this.state.address_backbase64Data}
                                                    />
                                                    )}
                                                </Grid>
                                                <Grid item xs={12} md={6}>
                                                    {userData.current_bond && (<AddImagesBox
                                                        title='Current Bond'
                                                        handleDrop={this.handleCurrentDropBack}
                                                        handleDropRejected={handleDropRejected}
                                                        userData={userData}
                                                        state={this.state}
                                                        imageUploaded={this.state.imageUploaded}
                                                        front_imageId={this.state.front_imageId}
                                                        imgUrl={[userData.current_bond.small]}
                                                        base64={this.state.current_bondbase64Data}
                                                    />
                                                    )}
                                                </Grid>
                                                {/* <Box sx={{display:'flex', flexDirection:'column', rowGap:2,width:'100%'}}>
                             
                                                    </Box> */}
                                                {/* {userData.identity_front && (
                                                    <Grid className="m-2">
                                                        <Grid container spacing={2}>
                                                            <Grid key={0} className="row" item>
                                                                {!userData.disable_sensitive_info && <div className="drop-box" style={{ width: 200, height: 120 }}>
                                                                    <p>Identity Back</p>
                                                                    <Dropzone
                                                                        onDrop={this.handleDropBack}
                                                                        accept="image/jpeg,image/jpg,image/png"
                                                                        multiple={true}
                                                                        maxSize={10485760}
                                                                        onDropRejected={handleDropRejected}
                                                                    >
                                                                        {({ getRootProps, getInputProps }) => (
                                                                            <div {...getRootProps()}>
                                                                                <input {...getInputProps()} />
                                                                                <p>
                                                                                    <FormattedMessage
                                                                                        id="customer.dropfiles"
                                                                                        defaultMessage="Drop files here, or click to select files"
                                                                                    />
                                                                                </p>
                                                                            </div>
                                                                        )}
                                                                    </Dropzone>
                                                                </div>}
                                                                {this.state.imageIdBackUploaded ?
                                                                    <Paper elevation={3}>
                                                                        <Image src={this.state.back_imageId.url} style={{ width: 200, height: 120 }} />
                                                                    </Paper> : <Paper elevation={3}>
                                                                        <Image src={userData.identity_back.small} thumbnail style={{ width: 200, height: 120 }} />
                                                                    </Paper>}
                                                            </Grid>
                                                        </Grid>
                                                    
                                                    </Grid>)} */}
                                            </Grid>
                                        </Grid>
                                        {/* <div style={{ backgroundColor: "white" }} className="col-md-12 custom-input-text"> */}
                                        <Box width='100%'>
                                            <Table className="table bordered custom-input-text" >



                                                <TableBody>
                                                    <TableRow>
                                                        <TableCell style={{ width: "40%", padding: "33px" }} className="text-left">
                                                            <FormattedMessage
                                                                id="adddob"
                                                                defaultMessage="DOB:"
                                                            />
                                                        </TableCell>
                                                        <TableCell style={{ padding: "0" }} className="text-left">
                                                            <div style={{ backgroundColor: "white", paddingLeft: 30, paddingRight: 30, marginTop: 10, marginBottom: 30 }} className="col-md-12 custom-input-text dod">

                                                                <form className="form-new">
                                                                    {/* <TextField
                                                    className="login-form-textfield"
                                                    id="date"
                                                    label="Date Of Birth"
                                                    type="date"
                                                    fullWidth={true}
                                              
                                                    placeholder={"Date Of Birth"}
                                                    value={this.state.dob}
                                                    onChange={
                                                        this.onFromChangeDate
                                                    }
                                                /> */}
                                                                    {/* <DatePicker id="example-datepicker"  placeholder={"Date Of Birth"} 
                                                   value={this.state.dob} onChange={
                                                        this.onFromChangeDate
                                                    }/> */}
                                                                    <FormControl
                                                                        fullWidth
                                                                        className="login-form-textfield dateof"
                                                                    >
                                                                        <Datetime

                                                                            open={
                                                                                this.state
                                                                                    .openDateTime
                                                                            }
                                                                            viewDate={moment().format('MM/DD/YYYY')}
                                                                            format={"MM/DD/YYYY"}
                                                                            isValidDate={valid}
                                                                            timeFormat={false}
                                                                            onChange={
                                                                                this.onFromChangeDate
                                                                            }
                                                                            value={
                                                                                this.state.dob
                                                                            }


                                                                            inputProps={{
                                                                                placeholder: this.props.intl.formatMessage(
                                                                                    {
                                                                                        id: 'Date Of Birth'

                                                                                    }

                                                                                )

                                                                            }}
                                                                            dob={"Date Of Birth"}


                                                                        />
                                                                    </FormControl>


                                                                    {/* <LocalizationProvider dateAdapter={AdapterDateFns}> */}
                                                                    {/* <Stack spacing={3}> */}
                                                                    {/* <MobileDatePicker
                                                        label="Date Of Birth"
                                                        inputFormat="MM/dd/yyyy"
                                                        onChange={
                                                            this.onFromChangeDate
                                                        }
                                                        value={
                                                            this.state.dob
                                                        }
                                                        renderInput={(params) => <TextField {...params} />}
                                                        /> */}
                                                                    {/* </Stack> */}
                                                                    {/* </LocalizationProvider> */}
                                                                </form>
                                                            </div>
                                                        </TableCell>
                                                    </TableRow>
                                                    {/* SSN Number  */}
                                                    <TableRow>
                                                        <TableCell style={{ width: "40%", padding: "33px" }} className="text-left">
                                                            <FormattedMessage
                                                                id="addssn"
                                                                defaultMessage="SSN:"
                                                            />
                                                        </TableCell>
                                                        <TableCell style={{ padding: "0" }} className="text-left">
                                                            <div className="col-md-12 custom-input-text">

                                                                <form className='form-new'  >
                                                                    {/* <TextField
                                                    className="login-form-textfield"
                                                    id="ssn"
                                                    label="SSN"
                                                    type="number"
                                                    onInput = {(e) =>{
                                                        e.target.value = Math.max(0, parseInt(e.target.value) ).toString().slice(0,9)
                                                    }}
                                                    fullWidth={true}
                                                    name="ssn"
                                                    placeholder={"Enter SSN"}
                                                    value={this.state.ssn}
                                                    onChange={event =>  {this.setState({
                                                        ssn: event.target.value,
                                                    })}}
                                                /> */}
                                                                    <TextField
                                                                        style={{ background: "none" }}
                                                                        className="login-form-textfield driver"
                                                                        id="adssn"
                                                                        label="SSN Number"
                                                                        type="tel"
                                                                        fullWidth={true}
                                                                        name="ssn"
                                                                        placeholder={"Enter SSN Number"}
                                                                        value={this.state.ssn}
                                                                        onChange={event => {
                                                                            if (event.target.value.length > 11) {
                                                                                return
                                                                            }
                                                                            const formatNum = event.target.value.replace(/(\d{3})(\d{2})(\d{4})/, "$1-$2-$3");

                                                                            this.setState({
                                                                                ssn: formatNum,
                                                                                errors: {
                                                                                    ...this.state.errors,
                                                                                    [event.target.name]: this.validate(event.target.name, event.target.value)
                                                                                },
                                                                            });
                                                                        }}
                                                                    // onInput = {(e) =>{
                                                                    //     e.target.value = Math.max(0, parseInt(e.target.value) ).toString().slice(0,15)
                                                                    // }}
                                                                    />



                                                                    {/* <div className="master-form-group ssn_num">
                                                    <input  name="ssn"
                                                    
                                                       
                                                        
                                                        onChange={event => {
                                                           
                                                        }}
                                                        placeholder="SSN Number"
                                                        className={"master-input " + (errors.ssn ? 'master-input-error' : '')} />
                                                    <br />
                                                    <span className="text-danger text-left">{errors.ssn}</span>
                                                </div> */}
                                                                </form>



                                                            </div>
                                                        </TableCell>
                                                    </TableRow>
                                                    {/* Driver License Number */}
                                                    <TableRow>
                                                        <TableCell style={{ width: "40%", padding: "33px" }} className="text-left">
                                                            <FormattedMessage
                                                                id="adddl"
                                                                defaultMessage="Driver License Number:"
                                                            />
                                                        </TableCell>
                                                        <TableCell style={{ padding: "0" }} className="text-left">
                                                            <div className="col-md-12 custom-input-text">

                                                                <form className="form-new">
                                                                    <TextField

                                                                        className="login-form-textfield driver"
                                                                        id="driver"
                                                                        label="Driver License Number"
                                                                        type="text"
                                                                        fullWidth={true}
                                                                        name="driver"
                                                                        placeholder={"Enter Driver License Number"}
                                                                        value={this.state.driver_license}
                                                                        onChange={event => {
                                                                            this.setState({
                                                                                driver_license: event.target.value,
                                                                            });
                                                                        }}
                                                                    // onInput = {(e) =>{
                                                                    //     e.target.value = Math.max(0, parseInt(e.target.value) ).toString().slice(0,15)
                                                                    // }}
                                                                    />
                                                                </form>
                                                            </div>
                                                        </TableCell>
                                                    </TableRow>



                                                </TableBody>
                                            </Table>
                                        </Box>




                                        <div className="col-md-12 d-flex" style={{
                                            justifyContent: "center", marginTop: '10px',
                                            marginBottom: '10px'
                                        }}>
                                            {this.state.buttonSaveLoader ? <CircularProgress /> :
                                                <React.Fragment>
                                                    {
                                                        userData.role == ROLE_PROVIDER && userData.show_underreview ?
                                                            null :
                                                            <button
                                                                className="custom-button"
                                                                onClick={() => this.updateValidStateAndSSN()}
                                                            >
                                                                SAVE
                                                            </button>
                                                    }
                                                </React.Fragment>
                                            }
                                        </div>
                                    </div>

                                </ExpansionPanelDetails>
                            </ExpansionPanel>
                        </React.Fragment>
                    )}
                    {/** Identity Proof Ends **/}

                    {/* {userData.role == ROLE_PROVIDER && (
                        <React.Fragment>
                            <ExpansionPanel>
                                <ExpansionPanelSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography>Proof of Business Address</Typography>
                                </ExpansionPanelSummary>
                                <ExpansionPanelDetails>
                                    <Grid container spacing={2}>
                                        <Grid container xs={12}>
                                            <Grid container spacing={2}>
                                                {userData.address_front && (
 <Grid className="m-2">
                                                    <Grid container spacing={2}>
                                                        <Grid key={0} className="row" item>
                                                            {!userData.disable_sensitive_info && <div className="drop-box" style={{ width: 200, height: 120 }}>
                                                                <p>Address</p>
                                                                <Dropzone
                                                                    onDrop={this.handleFrontAddDrop}
                                                                    accept="image/jpeg,image/jpg,image/png"
                                                                    multiple={true}
                                                                    maxSize={10485760}
                                                                    onDropRejected={handleDropRejected}
                                                                >
                                                                    {({ getRootProps, getInputProps }) => (
                                                                        <div {...getRootProps()}>
                                                                            <input {...getInputProps()} />
                                                                            <p>
                                                                                <FormattedMessage
                                                                                    id="customer.dropfiles"
                                                                                    defaultMessage="Drop files here, or click to select files"
                                                                                />
                                                                            </p>
                                                                        </div>
                                                                    )}
                                                                </Dropzone>
                                                            </div>}
                                                            {this.state.imageAddFrontUploaded ?
                                                                <Paper elevation={3}>
                                                                    <Image src={this.state.front_imageAdd.url} style={{ width: 200, height: 120 }} />
                                                                </Paper> : <Paper elevation={3}>
                                                                    <Image src={userData.address_front.small} thumbnail style={{ width: 200, height: 120 }} />
                                                                </Paper>}
                                                        </Grid>
                                                    </Grid>
                                                    </Grid>

                                                )}
                                                {userData.address_back && (
                                                    <Grid className="m-2">
                                                        <Grid container spacing={2}>
                                                            <Grid key={0} className="row" item>
                                                                {!userData.disable_sensitive_info && <div className="drop-box" style={{ width: 200, height: 120 }}>
                                                                    <p>Current Insurance Certificate </p>
                                                                    <Dropzone
                                                                        onDrop={this.handleAddressDropBack}
                                                                        accept="image/jpeg,image/jpg,image/png"
                                                                        multiple={true}
                                                                        maxSize={10485760}
                                                                        onDropRejected={handleDropRejected}
                                                                    >
                                                                        {({ getRootProps, getInputProps }) => (
                                                                            <div {...getRootProps()}>
                                                                                <input {...getInputProps()} />
                                                                                <p>
                                                                                    <FormattedMessage
                                                                                        id="customer.dropfiles"
                                                                                        defaultMessage="Drop files here, or click to select files"
                                                                                    />
                                                                                </p>
                                                                            </div>
                                                                        )}
                                                                    </Dropzone>
                                                                </div>}
                                                                {this.state.imageAddBackUploaded ?
                                                                    <Paper elevation={3}>
                                                                        <Image src={this.state.back_imageAdd.url} style={{ width: 200, height: 120 }} />
                                                                    </Paper> : <Paper elevation={3}>
                                                                        <Image src={userData.address_back.small} thumbnail style={{ width: 200, height: 120 }} />
                                                                    </Paper>}
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                )}
                                                {userData.current_bond && (
                                                    <Grid className="m-2" >
                                                        <Grid container spacing={2}>
                                                            <Grid key={0} className="row" item>
                                                                {!userData.disable_sensitive_info && <div className="drop-box" style={{ width: 200, height: 120 }}>
                                                                    <p>Current Bond </p>
                                                                    <Dropzone
                                                                        onDrop={this.handleCurrentDropBack}
                                                                        accept="image/jpeg,image/jpg,image/png"
                                                                        multiple={true}
                                                                        maxSize={10485760}
                                                                        onDropRejected={handleDropRejected}
                                                                    >
                                                                        {({ getRootProps, getInputProps }) => (
                                                                            <div {...getRootProps()}>
                                                                                <input {...getInputProps()} />
                                                                                <p>
                                                                                    <FormattedMessage
                                                                                        id="customer.dropfiles"
                                                                                        defaultMessage="Drop files here, or click to select files"
                                                                                    />
                                                                                </p>
                                                                            </div>
                                                                        )}
                                                                    </Dropzone>
                                                                </div>}
                                                                {this.state.imageAddCurrentUploaded ?
                                                                    <Paper elevation={3}>
                                                                        <Image src={this.state.current_bondAdd.url} style={{ width: 200, height: 120 }} />
                                                                    </Paper> : <Paper elevation={3}>
                                                                        <Image src={userData.current_bond.small} thumbnail style={{ width: 200, height: 120 }} />
                                                                    </Paper>}
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                )}
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                </ExpansionPanelDetails>
                            </ExpansionPanel>
                        </React.Fragment>
                    )} */}

                    {/** Address Proof Ends **/}

                    {/* {userData.role == ROLE_PROVIDER && (
                        <React.Fragment>
                            <ExpansionPanel>
                                <ExpansionPanelSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography>Contractors License</Typography>
                                </ExpansionPanelSummary>
                                <ExpansionPanelDetails>
                                    <Grid container spacing={2}>
                                        <Grid container xs={12}>
                                            <Grid container spacing={2}>

                                                <Grid container spacing={2}>
                                                    <Grid key={0} className="row" item>
                                                        <div className="drop-box" style={{ width: 200, height: 120 }}>
                                                            <p>Contractors License</p>
                                                            <Dropzone
                                                                onDrop={this.handleCertificatDrop}
                                                                accept="image/jpeg,image/jpg,image/png"
                                                                multiple={true}
                                                                maxSize={10485760}
                                                                onDropRejected={handleDropRejected}
                                                            >
                                                                {({ getRootProps, getInputProps }) => (
                                                                    <div {...getRootProps()}>
                                                                        <input {...getInputProps()} />
                                                                        <p>
                                                                            <FormattedMessage
                                                                                id="customer.dropfiles"
                                                                                defaultMessage="Drop files here, or click to select files"
                                                                            />
                                                                        </p>
                                                                    </div>
                                                                )}
                                                            </Dropzone>
                                                        </div>

                                                        {this.state.certificates.length > 0 &&
                                                            this.state.certificates.map((value, index) => (
                                                                < Paper elevation={3} className="p-1">
                                                                    <Image src={value.preview} style={{ width: 200, height: 120 }} />
                                                                </Paper>
                                                            ))}
                                                    </Grid>
                                                </Grid>
                                                <Grid container spacing={2} className="mt-2">
                                                    {this.state.userUploadedCertificates.map((value, index) => (
                                                        <Grid key={index} item className="p-1">
                                                            <Paper elevation={3}>
                                                                <Image src={value.small} thumbnail style={{ width: 200, height: 120 }} />
                                                            </Paper>
                                                            <HighlightOff style={{ position: "initial", top: 5, right: 5, color: "red" }}
                                                                onClick={() => {
                                                                    this.removeImage(value.small)
                                                                }} />
                                                        </Grid>
                                                    ))}
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </ExpansionPanelDetails>
                            </ExpansionPanel>
                        </React.Fragment>
                    )} */}
                    {/** Awards and certificates end **/}



                    {/** Bank details end **/}
                    {userData.role == ROLE_PROVIDER && (
                        <React.Fragment>
                            {/* expanded={errors.bank_name?true:false} */}
                            {/* <ExpansionPanel  expanded={expanded === 'panel1'} onChange={this.handleChange('panel1')}    className="showdata"></ExpansionPanel> */}
                            <ExpansionPanel className="showdata">
                                <ExpansionPanelSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography>Bank Details *</Typography>
                                </ExpansionPanelSummary>

                                <ExpansionPanelDetails id="data-header">
                                    <Box width='100%'>
                                        <Table className="table bordered custom-input-text">
                                            <TableBody>

                                                <TableRow>
                                                    <TableCell style={{ padding: "33px" }} className="text-left">
                                                        <FormattedMessage
                                                            id="bank_name"
                                                            defaultMessage="Bank Name"
                                                        />
                                                        :
                                                    </TableCell>
                                                    <TableCell style={{ padding: "0" }} className="text-left">
                                                        <form className="form-new">
                                                            <TextField
                                                                className="login-form-textfield"
                                                                id="bank_name"
                                                                label="Bank Name"

                                                                fullWidth={true}
                                                                name="bank_name"
                                                                // disabled={userData.disable_sensitive_info}
                                                                value={this.state.bank_name}
                                                                placeholder="Bank Name"

                                                                onChange={event => {
                                                                    this.setState({
                                                                        bank_name: event.target.value,
                                                                        errors: {
                                                                            ...this.state.errors,
                                                                            [event.target.name]: this.validate(event.target.name, event.target.value)
                                                                        },
                                                                        fields: {
                                                                            ...this.state.fields,
                                                                            [event.target.name]: event.target.value
                                                                        },
                                                                    });
                                                                }}
                                                            />
                                                            <br /> <span className="text-danger">{errors.bank_name}</span>
                                                        </form>
                                                        {/* <form autoComplete="off" onSubmit={this.handleSubmit}>
                                         <div className="master-form-group">
                                             <input  type="text" 
                                             name="bank_name"                           
                                             disabled={userData.disable_sensitive_info}
                                             value={this.state.bank_name} 
                                             onChange={event => {
                                                    this.setState({
                                                        bank_name: event.target.value,
                                                        errors: {
                                                            ...this.state.errors,
                                                            [event.target.name]: this.validate(event.target.name, event.target.value)
                                                        },
                                                        fields: {
                                                            ...this.state.fields,
                                                            [event.target.name]: event.target.value
                                                        },
                                                    });
                                                }}
                                       placeholder="Bank Name" 
                                       className={"master-input " + (errors.bank_name ? 'master-input-error' : '')} />
                                          <br /> <span className="text-danger">{errors.bank_name}</span>
                                       </div>
                                       </form> */}



                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ padding: "33px" }} className="text-left">
                                                        <FormattedMessage
                                                            id="account_holder_name"
                                                            defaultMessage="Account Holder Name"
                                                        />
                                                        :
                                                    </TableCell>
                                                    <TableCell style={{ padding: "0" }} className="text-left">
                                                        <form className="form-new" noValidate>
                                                            <TextField
                                                                required
                                                                className="login-form-textfield"
                                                                id="accountholder"
                                                                label="Account Holder Name"
                                                                error={account_holder_nameerror ? true : false}
                                                                fullWidth={true}
                                                                helperText={account_holder_nameerror}
                                                                name="account_holder_name"
                                                                placeholder="Account Holder Name"
                                                                value={this.state.account_holder_name}
                                                                onChange={event => {
                                                                    this.setState({
                                                                        account_holder_name: event.target.value,
                                                                        errors: {
                                                                            ...this.state.errors,
                                                                            [event.target.name]: this.validate(event.target.name, event.target.value)
                                                                        },
                                                                        fields: {
                                                                            ...this.state.fields,
                                                                            [event.target.name]: event.target.value
                                                                        },
                                                                    });
                                                                }}
                                                            // disabled={userData.disable_sensitive_info}
                                                            />
                                                            <br />
                                                            <span className="text-danger">{errors.account_holder_name}</span>
                                                        </form>


                                                        {/* <form autoComplete="off" onSubmit={this.handleSubmit}>
                                         <div className="master-form-group">
                                             <input  type="text" 
                                             name="account_holder_name"  
                                             disabled={userData.disable_sensitive_info}
                                             value={this.state.account_holder_name} 
                                             onChange={event => {
                                                    this.setState({
                                                        account_holder_name: event.target.value,
                                                        errors: {
                                                            ...this.state.errors,
                                                            [event.target.name]: this.validate(event.target.name, event.target.value)
                                                        },
                                                        fields: {
                                                            ...this.state.fields,
                                                            [event.target.name]: event.target.value
                                                        },
                                                    });
                                                }}
                                                placeholder="Account Holder Name" 
                                                className={"master-input " + (errors.account_holder_name ? 'master-input-error' : '')} />
                                                       <br />
                                                    <span className="text-danger">{errors.account_holder_name}</span>
                                        </div>
                                        </form> */}



                                                    </TableCell>
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell style={{ padding: "33px" }} className="text-left">
                                                        <FormattedMessage
                                                            id="account_number"
                                                            defaultMessage="Account Number"
                                                        />
                                                        :
                                                    </TableCell>
                                                    <TableCell style={{ padding: "0" }} className="text-left">
                                                        <form className="form-new">
                                                            <TextField

                                                                className="login-form-textfield"
                                                                id="accountnumber"
                                                                type="number"
                                                                label="Account Number"
                                                                error={account_numbererror ? true : false}
                                                                fullWidth={true}
                                                                helperText={account_numbererror}
                                                                name="account_number"
                                                                // onInput = {(e) =>{
                                                                //     e.target.value = Math.max(0, parseInt(e.target.value) ).toString().slice(0,20)
                                                                // }}

                                                                value={this.state.account_number}
                                                                onChange={event => {
                                                                    this.setState({
                                                                        account_number: event.target.value,
                                                                        errors: {
                                                                            ...this.state.errors,
                                                                            [event.target.name]: this.validate(event.target.name, event.target.value)
                                                                        },
                                                                        fields: {
                                                                            ...this.state.fields,
                                                                            [event.target.name]: event.target.value
                                                                        },
                                                                    });
                                                                }}
                                                                placeholder="Account Number"
                                                                required
                                                            // disabled={userData.disable_sensitive_info}


                                                            />
                                                            <br />
                                                            <span className="text-danger">{errors.account_number}</span>
                                                        </form>

                                                        {/* <form autoComplete="off" onSubmit={this.handleSubmit}>
                                   <div className="master-form-group">
                                    <input  type="number" name="account_number" 
                                      disabled={userData.disable_sensitive_info}  value={this.state.account_number}  
                                      onChange={event => {
                                                    this.setState({
                                                        account_number: event.target.value,
                                                        errors: {
                                                            ...this.state.errors,
                                                            [event.target.name]: this.validate(event.target.name, event.target.value)
                                                        },
                                                        fields: {
                                                            ...this.state.fields,
                                                            [event.target.name]: event.target.value
                                                        },
                                                    });
                                                }}
                                       placeholder="Account Number" 
                                       className={"master-input " + (errors.account_number ? 'master-input-error' : '')} />
                                          <br />
                                           <span className="text-danger">{errors.account_number}</span>
                                            </div>
                                            </form> */}

                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ padding: "33px" }} className="text-left">
                                                        <FormattedMessage
                                                            id="confirm_account_number"
                                                            defaultMessage="Confirm Account Number"
                                                        />
                                                        :
                                                    </TableCell>
                                                    <TableCell style={{ padding: "0" }} className="text-left">
                                                        <form className="form-new">
                                                            <TextField

                                                                className="login-form-textfield"
                                                                id="confirmaccountnumber"
                                                                type="number"
                                                                label="Confirm Account Number"
                                                                error={account_numbererror ? true : false}
                                                                fullWidth={true}
                                                                helperText={account_numbererror}
                                                                name="confirm_account_number"
                                                                // onInput = {(e) =>{
                                                                //     e.target.value = Math.max(0, parseInt(e.target.value) ).toString().slice(0,20)
                                                                // }}

                                                                value={this.state.confirm_account_number}
                                                                onChange={event => {
                                                                    this.setState({
                                                                        confirm_account_number: event.target.value,
                                                                        errors: {
                                                                            ...this.state.errors,
                                                                            [event.target.name]: this.validate(event.target.name, event.target.value)
                                                                        },
                                                                        fields: {
                                                                            ...this.state.fields,
                                                                            [event.target.name]: event.target.value
                                                                        },
                                                                    });
                                                                }}
                                                                placeholder="Confirm Account Number"
                                                                required
                                                            // disabled={userData.disable_sensitive_info}


                                                            />
                                                            <br />
                                                            <span className="text-danger">{errors.account_number}</span>
                                                        </form>

                                                        {/* <form autoComplete="off" onSubmit={this.handleSubmit}>
                                   <div className="master-form-group">
                                    <input  type="number" name="account_number" 
                                      disabled={userData.disable_sensitive_info}  value={this.state.account_number}  
                                      onChange={event => {
                                                    this.setState({
                                                        account_number: event.target.value,
                                                        errors: {
                                                            ...this.state.errors,
                                                            [event.target.name]: this.validate(event.target.name, event.target.value)
                                                        },
                                                        fields: {
                                                            ...this.state.fields,
                                                            [event.target.name]: event.target.value
                                                        },
                                                    });
                                                }}
                                       placeholder="Account Number" 
                                       className={"master-input " + (errors.account_number ? 'master-input-error' : '')} />
                                          <br />
                                           <span className="text-danger">{errors.account_number}</span>
                                            </div>
                                            </form> */}

                                                    </TableCell>
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell style={{ padding: "33px" }} className="text-left">
                                                        <FormattedMessage
                                                            id="rtn"
                                                            defaultMessage="RTN"
                                                        />
                                                        :
                                                    </TableCell>




                                                    <TableCell style={{ padding: "0" }} className="text-left">
                                                        {/* <form className="form-new" noValidate>
                                                        <TextField
                                                            className="login-form-textfield"
                                                            // className={formErrors.rtn.length > 0 ? "error" : null}
                                                            id="rtn"
                                                            fullWidth={true}
                                                            name="rtn"
                                                            label="RTN"
                                                            // inputProps={{
                                                            //     maxLength: 10
                                                            //   }}
                                                            // error={rtnerror ? true : false}
                                                            // helperText={rtnerror}
                                                            placeholder={"Enter RTN"}
                                                            value={this.state.rtn}
                                                            onChange={event => {
                                                                this.setState({
                                                                    rtn: event.target.value,
                                                                    // rtnerror:''
                                                                });
                                                            }}
                                                            // required
                                                            disabled={userData.disable_sensitive_info}
                                                            // type="number"
                                                            // onInput = {(e) =>{
                                                            //     e.target.value = Math.max(0, parseInt(e.target.value) ).toString().slice(0,9)
                                                            // }}
                                                        />
                                                       
                                                    </form> */}
                                                        {/* {formErrors.rtn.length > 0 && (
                                                            <span className="errorMessage">{formErrors.rtn}</span>
                                                        )} */}

                                                        {/* <div className="register-form">
        <Formik
          initialValues={initialValues}
          validationSchema={this.validationSchema}
          onSubmit={this.handleSubmit}
        >
            <Form>
              <div className="form-group">
                <Field name="rtn" 
                    type="number"
                    className="form-control" 
                    value={this.state.rtn}
                    onChange={event =>
                    {this.setState({rtn: event.target.value,});}}   
                    disabled={userData.disable_sensitive_info} />
                <ErrorMessage
                  name="rtn"
                  component="div"
                  className="text-danger"
                />
              </div>
            </Form>
        </Formik>

        
      </div>  */}
                                                        <form className="form-new">
                                                            <TextField
                                                                className="login-form-textfield"
                                                                id="rtn"
                                                                type="number"
                                                                name="rtn"
                                                                inputProps={{
                                                                    maxlength: 9
                                                                }}
                                                                // disabled={userData.disable_sensitive_info}
                                                                value={this.state.rtn}
                                                                onChange={event => {
                                                                    if (event.target.value.length > 9) {
                                                                        return
                                                                    }
                                                                    this.setState({
                                                                        rtn: event.target.value,
                                                                        errors: {
                                                                            ...this.state.errors,
                                                                            [event.target.name]: this.validate(event.target.name, event.target.value)
                                                                        },

                                                                    });
                                                                }}
                                                                placeholder="RTN Number"
                                                                label="RTN Number"
                                                                error={rtnerror ? true : false}
                                                                fullWidth={true}
                                                                helperText={rtnerror}

                                                                // onInput = {(e) =>{
                                                                //     e.target.value = Math.max(0, parseInt(e.target.value) ).toString().slice(0,20)
                                                                // }}

                                                                required



                                                            />
                                                            <br />
                                                            <span className="text-danger">{errors.rtn}</span>
                                                        </form>
                                                        {/* <form autoComplete="off" onSubmit={this.handleSubmit}>
                                         <div className="master-form-group">
                                             <input  type="number" 
                                             name="rtn"  
                                             disabled={userData.disable_sensitive_info}
                                             value={this.state.rtn} 
                                             onChange={event => {
                                                    this.setState({
                                                        rtn: event.target.value,
                                                        errors: {
                                                            ...this.state.errors,
                                                            [event.target.name]: this.validate(event.target.name, event.target.value)
                                                        },
                                                    
                                                    });
                                                }}
                                       placeholder="RTN Number" 
                                       className={"master-input " + (errors.rtn ? 'master-input-error' : '')} />
                                       <br />
                                        <span className="text-danger">{errors.rtn}</span>
                                       </div>
            
                                       </form> */}
                                                    </TableCell>
                                                </TableRow>


                                            </TableBody>
                                        </Table>
                                        <div className="col-md-12 d-flex" style={{
                                            justifyContent: "center", marginTop: '10px',
                                            marginBottom: '10px'
                                        }}>
                                            {this.state.buttonSaveLoader ? <CircularProgress /> :
                                                <React.Fragment>
                                                    {
                                                        userData.role == ROLE_PROVIDER && userData.show_underreview ?
                                                            null :
                                                            <button
                                                                className="custom-button"
                                                                onClick={() => this.updateBankDetails()}
                                                            >
                                                                SAVE
                                                            </button>
                                                    }
                                                </React.Fragment>
                                            }
                                        </div>
                                    </Box>
                                </ExpansionPanelDetails>
                            </ExpansionPanel>
                        </React.Fragment>
                    )}
                    {userData.role == ROLE_PROVIDER && userData.account_type == 2 && (
                        <React.Fragment>

                            <ExpansionPanel>
                                <ExpansionPanelSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    {console.warn(this.state.contractor_licensebase64Data)}
                                    <Typography >About Business *</Typography>
                                </ExpansionPanelSummary>
                                <ExpansionPanelDetails>
                                    <Box width='100%'>
                                        <Grid container spacing={2}>
                                            <Grid item key={'image'} xs={12}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 3 }}>
                                                    <AddImagesBox
                                                        title='Contractor License ID'
                                                        handleDrop={this.handleCertificatDrop}
                                                        handleDropRejected={handleDropRejected}
                                                        userData={userData}
                                                        state={this.state}
                                                        imageUploaded={this.state.imageUploaded}
                                                        front_imageId={this.state.front_imageId}
                                                        imgUrl={userData.business_images.length > 0 ?
                                                            [userData.business_images[0].small]
                                                            : ['https://staging-api.ezprohome.com/images/default/add_image.png']}
                                                        base64={this.state.contractor_licensebase64Data}
                                                    // onlyAdd={true}
                                                    />
                                                </Box>
                                            </Grid>

                                            {/* {userData.business_images.length > 0 && (
                                                <Grid container xs={12}>
                                                    <Grid container justify="center" spacing={2}>
                                                        {userData.business_images.length > 0 && (
                                                            <Grid key={0} item>
                                                                <Paper elevation={3}>
                                                                    <Image src={userData.business_images[0].small} thumbnail style={{ width: 200 }} />
                                                                </Paper>
                                                            </Grid>
                                                        )} */}

                                            {/* {userData.business_images.length > 1 && (
                                                            <Grid key={1} item>
                                                                <Paper elevation={3}>
                                                                    <Image src={userData.business_images[1].small} thumbnail style={{ width: 200 }} />
                                                                </Paper>
                                                            </Grid>
                                                        )}

                                                        {userData.business_images.length > 2 && (
                                                            <Grid key={2} item>
                                                                <Paper elevation={3}>
                                                                    <Image src={userData.business_images[2].small} thumbnail style={{ width: 200 }} />
                                                                </Paper>
                                                            </Grid>
                                                        )} */}
                                            {/* </Grid>
                                                </Grid>
                                            )} */}

                                            <Grid container xs={12}>

                                                <Table className="table bordered custom-input-text">
                                                    <TableBody>
                                                        <TableRow>
                                                            <TableCell style={{ padding: "33px" }} className="text-left">
                                                                <FormattedMessage
                                                                    id="contractor_no"
                                                                    defaultMessage="Contract License Number"
                                                                />
                                                                :
                                                            </TableCell>
                                                            <TableCell style={{ padding: "0" }} className="text-left">
                                                                <form className="form-new">
                                                                    <TextField
                                                                        className="login-form-textfield"
                                                                        id="contractor_no"
                                                                        fullWidth={true}
                                                                        label="Contractor License Number"
                                                                        type="text"

                                                                        name="contractor_no"
                                                                        placeholder={"Enter Contractor License Number"}
                                                                        value={this.state.contractor_number}
                                                                        onChange={event => {
                                                                            this.setState({
                                                                                contractor_number: event.target.value,
                                                                            });
                                                                        }}
                                                                    // disabled={userData.disable_sensitive_info}
                                                                    />
                                                                </form>
                                                            </TableCell>
                                                        </TableRow>
                                                        <TableRow>
                                                            <TableCell style={{ padding: "33px" }} className="text-left">
                                                                <FormattedMessage
                                                                    id="establishedOn"
                                                                    defaultMessage="Date of Establishment"
                                                                />
                                                                :
                                                            </TableCell>
                                                            <TableCell style={{ padding: "0" }} className="text-left ">
                                                                <div style={{ backgroundColor: "white", px: -5, marginTop: 10, marginBottom: 28 }} className="col-md-12 custom-input-text dod">

                                                                    <form className="form-new">
                                                                        <FormControl
                                                                            fullWidth
                                                                            sx={{ marginLeft: '-17px' }}
                                                                            className="login-form-textfield dateof"
                                                                        >
                                                                            <Datetime

                                                                                open={
                                                                                    this.state
                                                                                        .openDateTime
                                                                                }
                                                                                viewDate={moment().format('MM/DD/YYYY')}
                                                                                format={"MM/DD/YYYY"}
                                                                                isValidDate={valid}
                                                                                timeFormat={false}
                                                                                onChange={
                                                                                    this.onFromChangeDateEst
                                                                                }
                                                                                value={
                                                                                    this.state.est_date
                                                                                }


                                                                                inputProps={{
                                                                                    placeholder: this.props.intl.formatMessage(
                                                                                        {
                                                                                            id: 'establishedOn',
                                                                                            defaultMessage: "Date of Establishment"

                                                                                        }

                                                                                    )

                                                                                }}
                                                                                dob={"Date of Establishment"}


                                                                            />
                                                                        </FormControl>
                                                                    </form></div>
                                                            </TableCell>
                                                        </TableRow>
                                                        <TableRow>
                                                            <TableCell style={{ padding: "33px" }} className="text-left">
                                                                <FormattedMessage
                                                                    id="insurance_company_name"
                                                                    defaultMessage="Insurance Company Name"
                                                                />
                                                                :
                                                            </TableCell>
                                                            <TableCell style={{ padding: "0" }} className="text-left ">
                                                                <form className="form-new">
                                                                    <TextField
                                                                        // disabled={userData.disable_sensitive_info}
                                                                        className="login-form-textfield"
                                                                        id="inscompnyname"
                                                                        label="Insurance Company Name"
                                                                        fullWidth={true}
                                                                        name="inscompnyname"
                                                                        placeholder={"Enter Insurance Company Name"}
                                                                        value={this.state.insurance_company_name}
                                                                        onChange={event => {
                                                                            this.setState({
                                                                                insurance_company_name: event.target.value,
                                                                            });
                                                                        }}
                                                                    />
                                                                </form>

                                                            </TableCell>
                                                        </TableRow>
                                                        {/* <TableRow>
                                                        <TableCell className="text-left">
                                                            <FormattedMessage
                                                                id="website"
                                                                defaultMessage="Website"
                                                            />
                                                            :
                                        </TableCell>
                                                        <TableCell className="text-left">
                                                            {userData.website}
                                                        </TableCell>
                                                    </TableRow> */}
                                                        {/* <TableRow>
                                                        <TableCell className="text-left">
                                                            <FormattedMessage
                                                                id="establishedOn"
                                                                defaultMessage="Established On"
                                                            />
                                                            :
                                        </TableCell>
                                                        <TableCell className="text-left">
                                                            {userData.establishedOn
                                                                ? moment
                                                                    .unix(
                                                                        userData.establishedOn /
                                                                        1000
                                                                    )
                                                                    .format('DD-MMM-Y')
                                                                : ''}
                                                        </TableCell>
                                                    </TableRow> */}
                                                        {/* <TableRow>
                                                        <TableCell className="text-left">
                                                            <FormattedMessage
                                                                id="insurance_company_name"
                                                                defaultMessage="Insurance Company Name"
                                                            />
                                                            :
                                        </TableCell>
                                                        <TableCell className="text-left">
                                                            <form className="form-new">
                                                                <TextField
                                                                    className="login-form-textfield"
                                                                    id="inscompnyname"
                                                                    fullWidth={true}
                                                                    name="inscompany"
                                                                    placeholder={"Enter Insurance Company Name"}
                                                                    value={this.state.insurance_company_name}
                                                                    onChange={event => {
                                                                        this.setState({
                                                                            insurance_company_name: event.target.value,
                                                                        });
                                                                    }}
                                                                />
                                                            </div>

                                                        </TableCell>
                                                    </TableRow> */}
                                                        <TableRow>
                                                            <TableCell style={{ padding: "33px" }} className="text-left">
                                                                <FormattedMessage
                                                                    id="policy_no"
                                                                    defaultMessage="Policy Number"
                                                                />
                                                                :
                                                            </TableCell>
                                                            <TableCell style={{ padding: "0" }} className="text-left">
                                                                <form className="form-new">
                                                                    <TextField
                                                                        className="login-form-textfield"
                                                                        id="policyno"
                                                                        label="Policy Number"

                                                                        fullWidth={true}
                                                                        name="policyno"
                                                                        placeholder={"Enter Policy Number"}
                                                                        value={this.state.policy_number}
                                                                        onChange={event => {
                                                                            this.setState({
                                                                                policy_number: event.target.value,
                                                                            });
                                                                        }}
                                                                    // disabled={userData.disable_sensitive_info}
                                                                    />
                                                                </form>
                                                            </TableCell>
                                                        </TableRow>

                                                        <TableRow>
                                                            <TableCell style={{ padding: "33px" }} className="text-left">
                                                                <FormattedMessage
                                                                    id="expiry_date"
                                                                    defaultMessage="Date of Expiration"
                                                                />
                                                                :
                                                            </TableCell>
                                                            <TableCell style={{ padding: "0" }} className="text-left ">
                                                                <div style={{ backgroundColor: "white", marginTop: 10, marginBottom: 28 }} className="col-md-12 custom-input-text dod">

                                                                    <form className="form-new">
                                                                        <FormControl
                                                                            sx={{ marginLeft: '-17px' }}
                                                                            fullWidth
                                                                            className="login-form-textfield "
                                                                        >
                                                                            <Datetime

                                                                                open={
                                                                                    this.state
                                                                                        .openDateTime
                                                                                }
                                                                                viewDate={moment().format('MM/DD/YYYY')}
                                                                                format={"MM/DD/YYYY"}
                                                                                isValidDate={validexdate}
                                                                                timeFormat={false}
                                                                                onChange={
                                                                                    this.onFromChangeDateExp
                                                                                }
                                                                                value={
                                                                                    this.state.exp_date
                                                                                }


                                                                                inputProps={{
                                                                                    placeholder: this.props.intl.formatMessage(
                                                                                        {
                                                                                            id: 'expiry_date',
                                                                                            defaultMessage: "Date of Expiration"

                                                                                        }

                                                                                    )

                                                                                }}
                                                                                dob={"Date of Expiration"}


                                                                            />
                                                                        </FormControl>
                                                                    </form></div>
                                                            </TableCell>
                                                        </TableRow>
                                                        {/* <TableRow>
                                                        <TableCell className="text-left">
                                                            <FormattedMessage
                                                                id="expiry_date"
                                                                defaultMessage="Expiry Date"
                                                            />
                                                            :
                                        </TableCell>
                                                        <TableCell className="text-left">
                                                            {userData.expiry_date
                                                                ? moment
                                                                    .unix(
                                                                        userData.expiry_date /
                                                                        1000
                                                                    )
                                                                    .format('DD-MMM-Y')
                                                                : ''}
                                                        </TableCell>
                                                    </TableRow> */}
                                                        <TableRow>
                                                            <TableCell style={{ padding: "33px" }} className="text-left">
                                                                <FormattedMessage
                                                                    id="description"
                                                                    defaultMessage="Description"
                                                                />
                                                                :
                                                            </TableCell>
                                                            <TableCell style={{ padding: "0" }} className="text-left">
                                                                <form className="form-new">
                                                                    <TextField
                                                                        className="login-form-textfield"
                                                                        id="description"
                                                                        label="Description"

                                                                        fullWidth={true}
                                                                        name="description"
                                                                        placeholder={"Enter  Description"}
                                                                        value={this.state.business_description}
                                                                        onChange={event => {
                                                                            this.setState({
                                                                                business_description: event.target.value,
                                                                            });
                                                                        }}
                                                                    // disabled={userData.disable_sensitive_info}
                                                                    />
                                                                </form>
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableBody>
                                                </Table>
                                            </Grid>
                                        </Grid>
                                        <div className="col-md-12 d-flex" style={{ justifyContent: "center", marginTop: '10px', marginBottom: '10px' }}>
                                            {this.state.buttonSaveLoader ? <CircularProgress /> :
                                                <React.Fragment>
                                                    {
                                                        userData.role == ROLE_PROVIDER && userData.show_underreview ?
                                                            null :
                                                            <button
                                                                className="custom-button"
                                                                onClick={() => this.updateAboutBusiness()}
                                                            >
                                                                SAVE
                                                            </button>
                                                    }
                                                </React.Fragment>
                                            }
                                        </div>
                                    </Box>
                                </ExpansionPanelDetails>
                            </ExpansionPanel>
                        </React.Fragment>
                    )}
                    {/** About Business end**/}
                    {
                        userData.role == ROLE_PROVIDER && userData.show_underreview ?
                            null :
                            <div className="md-12">
                                <div className="col-md-12 d-flex" >
                                    <div className="row" style={{ alignItems: 'center', paddingTop: 2, margin: "0 15px" }}>
                                        {/* <Checkbox
                                label="Label"
                                checked={this.state.checked}
                                onChange={this.handleChange}
                                value="checkedA"
                                // checked={true}
                                /> */}
                                        <div className="check_div">
                                            <div style={{ margin: "0" }} className="form-group">
                                                <div className="form-check">
                                                    <input defaultChecked={this.state.isChecked} onChange={() => this.toggleChange()} className="form-check-input" type="checkbox" id="gridCheck" name="gridCheck" />
                                                    <label style={{ display: "flex" }} className="form-check-label" for="gridCheck">
                                                        <span className='terms_and_condition' onClick={this.handleClickOpen} ></span >
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <p style={{ margin: 0, paddingRight: 2 }}>
                                            I Agree to
                                        </p>
                                        <TermsConditions />

                                    </div>
                                </div>
                            </div>
                    }

                    {userData.role == ROLE_PROVIDER && (
                        <div className="md-12">
                            {/* <div className="col-md-12 d-flex" style={{ justifyContent: "center",    marginTop: '10px',
    marginBottom: '10px' }}>
                                {this.state.buttonSaveLoader ? <CircularProgress /> :
                                    <button
                                        className="custom-button"
                                        onClick={() => this.handleSubmit()}
                                    >
                                        SAVE CHANGES
                            </button>}
                            </div> */}
                            {console.warn(userData.rejected)}

                            <div className="col-md-12 d-flex" style={{ justifyContent: "center", }}>
                                {this.state.buttonSaveLoader ? <CircularProgress /> :
                                    <React.Fragment>
                                        {
                                            userData.role == ROLE_PROVIDER && userData.show_underreview ?
                                                null :
                                                <React.Fragment>
                                                    {userData.under_review == 1 && userData.review_status === false ?
                                                        <button style={{ height: "40px", padding: "11px", width: "25vw" }}
                                                            className="custom-button"
                                                            onClick={() => this.onProfileStatus()}
                                                        >
                                                            RE-SUBMIT FOR APPROVAL
                                                        </button> :
                                                        <button style={{ height: "40px", padding: "11px", width: "25vw" }}
                                                            className="custom-button"
                                                            onClick={() => this.onProfileStatus()}
                                                        >
                                                            SUBMIT FOR APPROVAL
                                                        </button>

                                                    }
                                                </React.Fragment>


                                        }
                                    </React.Fragment>
                                }
                            </div>
                            {/* {userData.role == ROLE_PROVIDER && !userData.show_underreview && userData.under_review == 2 && <div className="col-md-12 d-flex"
                                style={{ justifyContent: "center" }}>
                                {this.state.buttonLoader ? <CircularProgress /> :
                                    <button
                                        className="custom-button"

                                        onClick={() => this.onProfileStatus()}
                                    >
                                        SUBMIT FOR REVIEW
                                </button>}
                            </div>} */}

                        </div>
                    )}
                </div>
            </HOCLoader>
        );
    }
}

const composedComponent = compose(
    connect(null, actions)
);

export default composedComponent(withUser(injectIntl(InitialBasicCustomerProfile)));



// WEBPACK FOOTER //
// ./src/components/Customer/InitialBasicCustomerProfile.jsx